class CeramicaEuroConfigurator {

  constructor() {

    this.modal = document.getElementById('fxModal');

    this.configBtn = document.getElementById('fxStartConfig');

    this.configBtnStandalone = document.getElementById('fxStartConfigStandalone');

    this.configBtnPrimary = document.getElementById('fxStartConfigPrimary');

    this.close = document.getElementById('fxClose');

    this.success = document.getElementById('fxSuccess');

    this.currentStep = 1;

    this.maxSteps = 7; // Default: 7 step (destinazione, formato, finitura, colore, spessore, quantità, recap)

    this.configuration = {

      destination: null,

      format: null,

      finitura: null, // 🆕 Nuovo step finitura

      color: null,

      thickness: null,

      selectedVariant: null

    };

    this.product = JSON.parse(JSON.stringify(window.KH_PROD));

    // 🟢 Mappa LIVE: id variante -> prezzo unitario €/m² (unit_price) e barrato, da Shopify via Liquid
    this.unitMap = window.__KH_UNIT__ || {};

    // 🟢 Aggiunge unit_price (€/m²) ad ogni variante — Shopify lo omette in null' }}
    try { (this.product.variants || []).forEach(function(v){ var u = window.__KH_UNIT__[v.id]; if (u) { v.unit_price = u.p; v.kh_compare = u.c; } }); } catch(e){}

    // 🟢 Varianti COMPLETE da Shopify (con unit_price) come array globale: unica fonte prezzi del configuratore
    /* __KH_VARIANTS__ inline */

    this.currentVariant = window.__KH_CURVAR__;

    // Carousel state

    this.currentImageIndex = 0; // Inizia dalla prima immagine (indice 0)

    this.images = [];

    this.userInteracting = false; // Inizializza a false per permettere auto-rotazione

    // Specifiche tecniche caricate da JSON esterno

    this.ceramicaEuroSpecs = null;

    this.commonSpecs = null;

    // Specifiche dinamiche

    this.productSpecs = null;

    this.specsLoadedInAccordion = false;

    // Varianti reali Shopify

    this.variants = {

      all: []

    };

    this.init();

  }

  async init() {

    await this.loadSpecifications(); // Carica specifiche prima di tutto

    await this.initializeColorData();

    this.initializeVariantsData();

    this.setLowestPriceInHero();

    this.initializeCarousel();

    await this.initializeSpecsAccordion();

    this.initializeDynamicContent();

    this.setupEventListeners();

    this.updateStats();

    this.populateFormatsFromVariants();

    // V2 Improvements

    this.initRoomPreview();

    this.updateProgressBar();

  }

  async loadSpecifications() {

    try {

      const specsUrl = window.__KH_ASSETS__.specifiche;

      let specsData = null;

      try {

        const response = await fetch(specsUrl);

        if (response.ok) {

          specsData = await response.json();

        }

      } catch (e) {}

      if (specsData && specsData.collezioni) {

        this.ceramicaEuroSpecs = specsData.collezioni;

        this.commonSpecs = {

          technology: 'Gres Porcellanato di Alta Qualità',

          warranty: '24 mesi (garanzia legale)',

          certifications: 'Conforme normative CE',

          origin: 'Italia',

          maintenance: 'Facile pulizia con detergenti neutri',

          installation: 'Posa professionale consigliata'

        };

      } else {

        this.ceramicaEuroSpecs = [{

          nome: "Default",

          varianti: [{

            tipo: "Standard",

            codice: "STD-001",

            formati: ["60×60 cm", "30×60 cm"],

            spessore: "9 mm",

            materiale: "Gres porcellanato smaltato",

            colori: ["Grigio", "Beige", "Bianco"],

            finiture: ["R10", "V2 variazione colore", "Naturale"]

          }]

        }];

        this.commonSpecs = {

          technology: 'Gres Porcellanato di Alta Qualità',

          warranty: '24 mesi (garanzia legale)',

          certifications: 'Conforme normative CE',

          origin: 'Italia',

          maintenance: 'Facile pulizia con detergenti neutri',

          installation: 'Posa professionale consigliata'

        };

      }

    } catch (error) {

      // Usa valori di default in caso di errore

      this.ceramicaEuroSpecs = [{

        nome: "Default",

        varianti: [{

          tipo: "Standard",

          codice: "STD-001",

          formati: ["60×60 cm", "30×60 cm"],

          spessore: "9 mm",

          materiale: "Gres porcellanato smaltato",

          colori: ["Grigio", "Beige", "Bianco"],

          finiture: ["R10", "V2 variazione colore", "Naturale"]

        }]

      }];

      this.commonSpecs = {

        technology: 'Gres Porcellanato di Alta Qualità',

        warranty: '24 mesi (garanzia legale)',

        certifications: 'Conforme normative CE',

        origin: 'Italia',

        maintenance: 'Facile pulizia con detergenti neutri',

        installation: 'Posa professionale consigliata'

      };

    }

  }

  // INIZIALIZZAZIONE DATI COLORI DA JSON ESTERNO

  async initializeColorData() {

    try {

      // URL principale per i colori (Shopify asset)

      const colorsUrl = window.__KH_ASSETS__.formaaquae;

      const response = await fetch(colorsUrl);

      if (response.ok) {

        const colorData = await response.json();

        // Usa colorData se necessario

      }

    } catch (error) {

      // Fallback silenzioso - i colori verranno gestiti altrimenti

    }

  }

  setLowestPriceInHero(retryCount = 0) {

    if (!this.product.variants || this.product.variants.length === 0) {

      return;

    }

    /* KH-VARPRICE 2026-10-06: se l'URL contiene ?variant=, il prezzo sotto il titolo deve essere QUELLO della variante selezionata, non il minimo (altrimenti con un link di variante si vede un prezzo preciso ma sbagliato). */
    try {
      var _khVarId = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
      if (_khVarId) {
        var _khSel = this.product.variants.find(function (vv) { return String(vv.id) === String(_khVarId); });
        if (_khSel) {
          var _khU = this.khUnitCents ? this.khUnitCents(_khSel) : null;
          var _khMq = (_khU && _khU.price != null) ? _khU.price : (_khSel.unit_price != null ? parseFloat(_khSel.unit_price) : null);
          var _khBox = parseFloat(_khSel.price);
          var _khHero = document.getElementById('heroPrice');
          var _khHC = document.getElementById('heroComparePrice');
          /* KH-VARPRICE-BATT 2026-10-06: battiscopa (venduto a scatola, nessun €/mq) o variante senza prezzo unitario -> mostra SOLO il prezzo a scatola come prezzo principale, niente €/mq fuorviante. */
          var _khOpts = ((_khSel.option1 || '') + ' ' + (_khSel.option2 || '') + ' ' + (_khSel.option3 || '') + ' ' + (_khSel.title || '')).toLowerCase();
          var _khIsBatt = _khOpts.indexOf('battiscopa') !== -1 || _khMq == null;
          if (_khIsBatt) {
            if (_khHero && !isNaN(_khBox)) {
              _khHero.innerHTML = this.formatMoney(_khBox) + '<span style="font-size: 1em; color: inherit; font-weight: inherit;">/</span><span class="fx-price-unit">scatola</span>';
              _khHero.setAttribute('data-price-cents', _khBox);
            }
            var _khBL = document.getElementById('heroBoxLine');
            if (_khBL) { _khBL.style.display = 'none'; }
            if (_khHC) {
              var _khCmpB = (_khSel.compare_at_price != null && parseFloat(_khSel.compare_at_price) > _khBox) ? parseFloat(_khSel.compare_at_price) : null;
              if (_khCmpB) {
                var _khCsB = _khHC.querySelector('#heroComparePriceValue');
                if (_khCsB) { _khCsB.textContent = this.formatMoney(_khCmpB); } else { _khHC.textContent = this.formatMoney(_khCmpB); }
                _khHC.setAttribute('data-compare-price-cents', _khCmpB); _khHC.style.display = '';
              } else { _khHC.style.display = 'none'; }
            }
            return; /* battiscopa: solo €/scatola */
          }
          if (_khHero && _khMq != null) {
            var _khPs = _khHero.querySelector('#heroPriceValue');
            if (_khPs) { _khPs.textContent = this.formatMoney(_khMq); }
            else { _khHero.innerHTML = this.formatMoney(_khMq) + '<span style="font-size: 1em; color: inherit; font-weight: inherit;">/</span><span class="fx-price-unit">mq</span>'; }
            _khHero.setAttribute('data-price-cents', _khMq);
          }
          var _khHB = document.getElementById('heroBoxPrice');
          if (_khHB && !isNaN(_khBox)) { _khHB.textContent = this.formatMoney(_khBox) + '/scatola'; }
          if (_khHC) {
            var _khCmp = (_khU && _khU.compare != null) ? _khU.compare : null;
            if (_khCmp && _khMq != null && _khCmp > _khMq) {
              var _khCs = _khHC.querySelector('#heroComparePriceValue');
              if (_khCs) { _khCs.textContent = this.formatMoney(_khCmp); } else { _khHC.textContent = this.formatMoney(_khCmp); }
              _khHC.setAttribute('data-compare-price-cents', _khCmp); _khHC.style.display = '';
            } else { _khHC.style.display = 'none'; }
          }
          return; /* non sovrascrivere con il prezzo minimo */
        }
      }
    } catch (e) {}

    // Trova la variante con il prezzo più basso tra quelle disponibili

    const availableVariants = this.product.variants.filter(variant => variant.available);

    if (availableVariants.length === 0) {

      return;

    }

    // 🟢 LIVE da Shopify: minimo €/m² (unit_price) tra le varianti, via this.unitMap (sincrono)

    let lowestPrice, comparePrice;

    availableVariants.forEach(v => {

      const u = this.khUnitCents(v);

      if (!u) return;

      if (lowestPrice == null || u.price < lowestPrice) { lowestPrice = u.price; comparePrice = u.compare; }

    });

    // 🎯 USA cercaPrezzoMinimoProdotto per trovare il prezzo più basso tra TUTTI i formati

    if (!lowestPrice && ({}) && typeof window.cercaPrezzoMinimoProdotto === 'function') {

      // Trova il nome prodotto normalizzato usando SUPERGRES_PRODUCTS

      let prodottoNormalizzato = null;

      const titleLower = this.product.title.toLowerCase();

      if (window.SUPERGRES_PRODUCTS) {

        for (const [nome, chiave] of Object.entries(window.SUPERGRES_PRODUCTS).sort((a, b) => b[0].length - a[0].length)) {

          if (titleLower.includes(nome)) {

            prodottoNormalizzato = chiave;

            break;

          }

        }

      }

      if (prodottoNormalizzato) {

        const risultato = window.cercaPrezzoMinimoProdotto(({}), prodottoNormalizzato);
        if (risultato) {

          // 🎯 Moltiplica per 100 perché cercaPrezzoMinimoProdotto ritorna EURO, formatMoney aspetta CENTESIMI

          lowestPrice = Math.round(risultato.prezzo.prezzo * 100);

          comparePrice = null; /* KH-NOSCONTO 2026-08: barrato SOLO da compare_at reale Shopify, mai dal listino prezzi-fissi */

        }

      }

      // Fallback: cerca per formati generici se non trovato

      if (!lowestPrice) {

        const formatiTrovati = new Set();

        availableVariants.forEach(variant => {

          const variantText = `${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();

          const formatMatch = variantText.match(/(\d+)\s*x\s*(\d+)/);

          if (formatMatch) {

            formatiTrovati.add(`${formatMatch[1]}x${formatMatch[2]}`);

          }

        });

        let minPrezzo = null;

        let minComparePrice = null;

        formatiTrovati.forEach(formato => {

          if (({})[formato]) {

            const prezzoData = ({})[formato];

            const prezzoInCents = Math.round(prezzoData.prezzo * 100);

            const comparePriceInCents = Math.round(prezzoData.comparePrice * 100);

            if (minPrezzo === null || prezzoInCents < minPrezzo) {

              minPrezzo = prezzoInCents;

              minComparePrice = null; /* KH-NOSCONTO: niente barrato dal listino prezzi-fissi */

            }

          }

        });

        if (minPrezzo !== null) {

          lowestPrice = minPrezzo;

          comparePrice = minComparePrice;

        }

      }

    }

    // Fallback: Calcola prezzo minimo dalle varianti se non abbiamo prezzi fissi

    if (!lowestPrice) {

      const lowestPriceVariant = availableVariants.reduce((min, variant) => {

        return parseFloat(variant.price) < parseFloat(min.price) ? variant : min;

      });

      lowestPrice = parseFloat(lowestPriceVariant.price);

      comparePrice = (lowestPriceVariant.compare_at_price && parseFloat(lowestPriceVariant.compare_at_price) > lowestPrice) ?

        parseFloat(lowestPriceVariant.compare_at_price) :

        null;

    }

    /* KH-DEBUG-PREZZO hero rimosso 20/07: la console.log aveva una stringa multi-riga = SyntaxError che rompeva lo script */

    // Aggiorna prezzi nell'hero (solo una volta, non cambieranno più)

    const heroPrice = document.getElementById('heroPrice');

    const heroComparePrice = document.getElementById('heroComparePrice');

    if (heroPrice) {

      const priceSpan = heroPrice.querySelector('#heroPriceValue');

      if (priceSpan) {

        priceSpan.textContent = this.formatMoney(lowestPrice);

      } else {

        heroPrice.innerHTML = this.formatMoney(lowestPrice) + '<span style="font-size: 1em; color: inherit; font-weight: inherit;">/</span><span class="fx-price-unit">mq</span>';

      }

      heroPrice.setAttribute('data-price-cents', lowestPrice);

      // Prezzo scatola dalla variante con mq più basso (stessa variante del prezzo hero)
      const heroBoxPrice = document.getElementById('heroBoxPrice');
      if (heroBoxPrice && availableVariants && availableVariants.length > 0) {
        const nonBatt = availableVariants.filter(v => !(v.option1 || '').toLowerCase().includes('battiscopa'));
        const _pool = (nonBatt.length > 0 ? nonBatt : availableVariants);
        const _withUnit = _pool.filter(v => v.unit_price != null && parseFloat(v.unit_price) > 0);
        const best = (_withUnit.length > 0)
          ? _withUnit.reduce((min, v) => {
              /* KH-HEROMQ-v4: variante col euro/mq PIU' BASSO (coerente con le card collezione) */
              return parseFloat(v.unit_price) < parseFloat(min.unit_price) ? v : min;
            })
          : _pool.reduce((min, v) => parseFloat(v.price) < parseFloat(min.price) ? v : min);
        heroBoxPrice.textContent = this.formatMoney(parseFloat(best.price)) + '/scatola';
        /* KH-HEROMQ-v4: euro/mq della variante col mq piu basso (= card collezione) */
        if (best.unit_price != null && parseFloat(best.unit_price) > 0) {
          const khBmq = parseFloat(best.unit_price);
          const khPs = heroPrice.querySelector('#heroPriceValue');
          if (khPs) { khPs.textContent = this.formatMoney(khBmq); }
          else { heroPrice.innerHTML = this.formatMoney(khBmq) + '<span style="font-size: 1em; color: inherit; font-weight: inherit;">/</span><span class="fx-price-unit">mq</span>'; }
          heroPrice.setAttribute('data-price-cents', khBmq);
        }
      }

    }

    if (heroComparePrice) {

      if (comparePrice) {

        const comparePriceSpan = heroComparePrice.querySelector('#heroComparePriceValue');

        if (comparePriceSpan) {

          comparePriceSpan.textContent = this.formatMoney(comparePrice);

        } else {

          heroComparePrice.textContent = this.formatMoney(comparePrice);

        }

        heroComparePrice.setAttribute('data-compare-price-cents', comparePrice);

        heroComparePrice.style.display = '';

      } else {

        heroComparePrice.style.display = 'none';

      }

    }

    // Nascondi/mostra badge sconto
    const discountBadge = document.querySelector('.fx-discount-badge');
    if (discountBadge) {

      if (comparePrice && comparePrice > lowestPrice) {

        const pct = Math.round((comparePrice - lowestPrice) / comparePrice * 100);

        discountBadge.textContent = '';

        discountBadge.style.display = '';

      } else {

        discountBadge.style.display = 'none';

      }

    }

    const priceCard = document.querySelector('.fx-price-card');

    if (priceCard) {

      priceCard.style.opacity='1';

      setTimeout(()=>{var w=priceCard.offsetWidth;if(w>0){var b=document.querySelector('.fx-config-btn-standalone');if(b){b.style.width=w+'px';b.style.margin='0 auto';}var p=document.querySelector('.fx-payment-section');if(p){p.style.width=w+'px';p.style.margin='0 auto';}var t=document.querySelector('.fx-trust-badges');if(t){t.style.margin='1.25rem auto 0';}document.querySelectorAll('.fx-specs-accordion').forEach(a=>{a.style.maxWidth=w+'px';a.style.margin='0 auto';});}},100);

    }

  }

  // 🔧 INIZIALIZZAZIONE VARIANTI REALI SHOPIFY

  initializeVariantsData() {

    if (!this.product.variants) {

      return;

    }

    // Reset arrays

    this.variants = {

      all: [],

      byFormat: {},

      byColor: {},

      byThickness: {}

    };

    // Analizza ogni variante

    this.product.variants.forEach((variant, index) => {

      if (!variant.available) {

        return; // Salta varianti non disponibili

      }

      this.variants.all.push(variant);

      let formato = null;

      if (variant.option1 && variant.option1.match(/\d+\s*[x×]\s*\d+/i)) {

        formato = variant.option1;

      } else if (variant.title.match(/\d+\s*[x×]\s*\d+/i)) {

        formato = variant.title.match(/(\d+\s*[x×]\s*\d+)/i)[1];

      }

      let colore = variant.option2 || null;

      let spessore = variant.option3 || null;

      // Organizza per formato

      if (formato) {

        if (!this.variants.byFormat[formato]) {

          this.variants.byFormat[formato] = [];

        }

        this.variants.byFormat[formato].push(variant);

      }

      // Organizza per colore

      if (colore) {

        if (!this.variants.byColor[colore]) {

          this.variants.byColor[colore] = [];

        }

        this.variants.byColor[colore].push(variant);

      }

      // Organizza per spessore

      if (spessore) {

        if (!this.variants.byThickness[spessore]) {

          this.variants.byThickness[spessore] = [];

        }

        this.variants.byThickness[spessore].push(variant);

      }

    });

  }

  // 📐 POPOLA FORMATI UNICI DALLE VARIANTI

  populateFormatsFromVariants() {

    const container = document.getElementById('fxFormatsContainer');

    if (!container) return;

    container.innerHTML = '';

    // Ottieni formati unici

    const formatiUnici = Object.keys(this.variants.byFormat);

    if (formatiUnici.length === 0) {

      container.innerHTML = '<p>Nessun formato disponibile</p>';

      return;

    }

    formatiUnici.forEach((formato, index) => {

      const formatCard = document.createElement('div');

      formatCard.className = 'fx-format-card';

      formatCard.dataset.format = formato;

      // Estrai dimensioni dal formato per forma proporzionale

      const dims = this.parseFormatDimensions(formato);

      const maxSize = 80; // px massimo

      let shapeW, shapeH;

      if (dims) {

        const ratio = dims.w / dims.h;

        if (ratio >= 1) {

          shapeW = maxSize;

          shapeH = Math.max(20, Math.round(maxSize / ratio));

        } else {

          shapeH = maxSize;

          shapeW = Math.max(20, Math.round(maxSize * ratio));

        }

      } else {

        shapeW = 60;

        shapeH = 60;

      }

      // Subtitle con spessore/tipo se presente

      const subtitle = formato.includes('20') && formato.includes('mm') ? 'Outdoor 20mm' :

                       formato.includes('6') && formato.includes('mm') ? 'Slim 6mm' : '';

      formatCard.innerHTML = `

        <div class="fx-format-shape-container" style="height: ${maxSize + 25}px;">

          <div class="fx-format-shape-proportional" style="width: ${shapeW}px; height: ${shapeH}px;">

            ${dims ? `<span class="fx-format-dim-w">${dims.w} cm</span>` : ''}

            ${dims && dims.w !== dims.h ? `<span class="fx-format-dim-h">${dims.h} cm</span>` : ''}

          </div>

        </div>

        <div class="fx-format-info">

          <h4>${String(formato).replace(/\./g,',')}</h4>

          ${subtitle ? `<div class="fx-format-subtitle">${subtitle}</div>` : ''}

        </div>

      `;

      // Stagger animation delay

      formatCard.style.animationDelay = `${0.05 * (index + 1)}s`;

      formatCard.addEventListener('click', () => {

        document.querySelectorAll('.fx-format-card').forEach(card => {

          card.classList.remove('selected');

        });

        formatCard.classList.add('selected');

        this.configuration.formatSize = formato;

        this.configuration.format = 'STANDARD';
        try { console.log('[KH-SHIP] CLICK FORMATO formato=', formato); this.updateShipNote(formato, this.configuration.thickness); } catch(e) { console.log('[KH-SHIP] err formato', e); }

        document.getElementById('fxNext2').disabled = false;

        document.getElementById('fxNext2Finitura').disabled = false;

        this.populateColorsForFormat(formato);

        this.updateStickySummary();

      });

      container.appendChild(formatCard);

    });

  }

  // Helper: Estrai dimensioni dal formato (es. "120x280" → {w:120, h:280})

  parseFormatDimensions(formato) {

    if (!formato) return null;

    // Match patterns like "120x280", "60×60", "80x160"

    const match = formato.match(/(\d+)\s*[x×]\s*(\d+)/i);

    if (match) {

      return { w: parseInt(match[1]), h: parseInt(match[2]) };

    }

    return null;

  }

  // 🎨 POPOLA COLORI PER IL FORMATO SELEZIONATO

  populateColorsForFormat(formato) {

    // Trova tutte le varianti con questo formato

    const variantiFormato = this.variants.byFormat[formato] || [];

    const coloriSet = new Set();

    variantiFormato.forEach(variant => {

      if (variant.option2) {

        coloriSet.add(variant.option2);

      }

    });

    // Salva per uso futuro

    this.availableColors = Array.from(coloriSet);

  }

  // 📏 POPOLA SPESSORI PER FORMATO E COLORE

  populateThicknessForSelection(formato, colore) {

    // Trova varianti che corrispondono a formato e colore

    const variantiFiltrate = this.variants.all.filter(variant => {

      const matchFormat = variant.option1 === formato || 

                         (variant.title && variant.title.includes(formato));

      const matchColor = !colore || variant.option2 === colore || 

                        (variant.title && variant.title.includes(colore));

      return matchFormat && matchColor;

    });

    const spessoriSet = new Set();

    variantiFiltrate.forEach(variant => {

      if (variant.option3) {

        spessoriSet.add(variant.option3);

      }

    });

    return Array.from(spessoriSet);

  }

  // 🎯 CONTENUTI DINAMICI RANDOMICI BASATI SUL PRODOTTO

  initializeDynamicContent() {

    const productTitle = this.product.title.toLowerCase();

    const productType = this.product.type?.toLowerCase() || '';

    const productTags = this.product.tags || [];

    // Identifica categoria prodotto

    const category = this.identifyProductCategory(productTitle, productType, productTags);

    // Ottieni contenuti specifici per categoria con variazione randomica

    const content = this.getRandomizedProductContent(category);

    // Popola elementi dinamici

    this.populateDynamicContent(content);

  }

  getRandomizedProductContent(category) {
    /* KH 06/08: libreria contenuti dinamici rimossa (claim non verificati; #dynamicBenefits inesistente, era codice morto) */
    return { benefits: [] };
  }

  populateDynamicContent(content) {

    // Popola benefici

    const benefitsEl = document.getElementById('dynamicBenefits');

    if (benefitsEl) {

      benefitsEl.innerHTML = content.benefits.map(benefit => 

        `<div class="fx-benefit">${benefit}</div>`

      ).join('');

    }

    // Aggiorna descrizione del primo step

    const descEl = document.getElementById('dynamicDescription');

    if (descEl) {

      const categoryDescriptions = {

        bathtub: '🛁 Scegli la vasca perfetta per i tuoi momenti di relax quotidiano',

        sink: '🚿 Trova il lavabo ideale che unisce design e funzionalità',

        shower: '💎 Progetta il box doccia su misura per il tuo spazio',

        toilet: '🏠 Seleziona il sanitario che completa il tuo bagno moderno',

        furniture: ' Crea il mobile bagno che ottimizza ogni centimetro',

        tap: '✨ Scegli la rubinetteria che dona carattere al tuo bagno'

      };

      const category = this.identifyProductCategory(

        this.product.title.toLowerCase(),

        this.product.type?.toLowerCase() || '',

        this.product.tags || []

      );

      descEl.textContent = categoryDescriptions[category] || '✨ Progettato su misura per trasformare il tuo spazio in un\'oasi di stile';

    }

  }

  // 🎯 ACCORDION PER SPECIFICHE TECNICHE

  async initializeSpecsAccordion() {

    const accordion = document.getElementById('specsAccordion');

    const toggle = document.getElementById('specsToggle');

    const content = document.getElementById('specsContent');

    // Genera le specifiche subito per avere il conteggio corretto

    if (!this.productSpecs) {

      this.productSpecs = await this.analyzeProductAndGenerateSpecs();

    }

    // Aggiorna il contatore subito

    const countEls = document.querySelectorAll('.fx-specs-count');

    if (countEls.length && this.productSpecs) {

      const totalSpecs = Object.keys(this.productSpecs).length;

      countEls.forEach(el => el.textContent = `${totalSpecs} dettagli`);

    }

    // Se non c'è accordion (tab mode), carica le specs direttamente nella grid
    if (!accordion || !toggle) {
      await this.loadSpecsInAccordion();
      return;
    }

    toggle.addEventListener('click', async (e) => {

      e.preventDefault();

      const isActive = accordion.classList.contains('active');

      if (!isActive) {

        // Prima apertura: carica le specifiche se non già caricate

        if (!this.specsLoadedInAccordion) {

          await this.loadSpecsInAccordion();

        }

        accordion.classList.add('active');

      } else {

        accordion.classList.remove('active');

      }

      // Smooth scroll per mostrare il contenuto

      if (!isActive) {

        setTimeout(() => {

          content.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        }, 300);

      }

    });

    // Accordion Descrizione Prodotto

    const descAcc = document.getElementById('descAccordion');

    const descTog = document.getElementById('descToggle');

    const descCon = document.getElementById('descContent');

    if (descAcc && descTog) {

      descTog.addEventListener('click', (e) => {

        e.preventDefault();

        descAcc.classList.toggle('active');

        if (descAcc.classList.contains('active')) {

          setTimeout(() => { descCon.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 300);

        }

      });

    }

  }

  async loadSpecsInAccordion() {

    const loadingEl = document.getElementById('specsLoadingInline');

    const gridEl = document.getElementById('specsGridInline');

    if (!gridEl) return;

    // Mostra loading

    if (loadingEl) {

      loadingEl.style.display = 'flex';

    }

    // Se le specifiche non sono ancora state generate, generale

    if (!this.productSpecs) {

      this.productSpecs = await this.analyzeProductAndGenerateSpecs();

    }

    // Aggiorna il contatore

    const countEls2 = document.querySelectorAll('.fx-specs-count');

    if (countEls2.length) {

      const totalSpecs = Object.keys(this.productSpecs).length;

      countEls2.forEach(el => el.textContent = `${totalSpecs} dettagli`);

    }

    // Popola l'accordion con le specifiche

    gridEl.innerHTML = '';

    // SVG icons per ogni tipo di specifica (18px, inline)

    const _si = {

      formats: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>',

      thickness: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 12h20M2 4v16M22 4v16M7 8v8M12 6v12M17 8v8"/></svg>',

      material: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="6" width="20" height="4" rx="1"/><rect x="2" y="14" width="20" height="4" rx="1"/><path d="M12 6v4M7 14v4M17 14v4"/></svg>',

      colors: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="8" r="2.5" fill="currentColor"/><circle cx="8" cy="14" r="2.5" fill="currentColor"/><circle cx="16" cy="14" r="2.5" fill="currentColor"/></svg>',

      finishes: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18.37 2.63a1 1 0 0 1 1.41 0l1.59 1.59a1 1 0 0 1 0 1.41L9.41 17.59a1 1 0 0 1-.56.28l-3.56.59.59-3.56a1 1 0 0 1 .28-.56z"/><path d="M2 22h20"/></svg>',

      formatDetails: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></svg>',

      outdoor: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>',

      speciali: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>'

    };

    // Color mapping approssimativo per dots

    const _cm = {bianco:'#f5f5f0',white:'#f5f5f0',avorio:'#ede8d0',ivory:'#ede8d0',crema:'#f5e6c8',cream:'#f5e6c8',beige:'#d4c4a8',bone:'#e8dcc8',sabbia:'#c9b98a',sand:'#c9b98a',corda:'#b8a07a',tortora:'#8b7d6b',taupe:'#8b7d6b',visone:'#7a6855',greige:'#a89880',grigio:'#9e9e9e',grey:'#9e9e9e',gray:'#9e9e9e',silver:'#b0b0b0',cenere:'#a0a0a0',dark:'#3a3a3a',nero:'#2a2a2a',noir:'#2a2a2a',black:'#2a2a2a',orobico:'#5a5a6a',gold:'#c9a84c',oro:'#c9a84c',calacatta:'#f0ece4',statuario:'#f0ece8',statuarietto:'#eae6de',sahara:'#8a7a5a',panda:'#D9D2C5',pietra:'#6a6a6a',helsinki:'#e8e8e8',cappuccino:'#6f4e37',colonial:'#8b7355',agata:'#a8d8dc',azzurro:'#6fa8c8',verde:'#5a8a6a',green:'#5a8a6a',pink:'#d4a0a0',paonazzo:'#7a5a7a',paonazzetto:'#9a7a8a',zebrino:'#8a8a7a',oxford:'#5a5a5a',onyx:'#3a5a4a',mont:'#e0dcd4',extra:'#F5F2EB',universe:'#4a4a5a',venato:'#e0dcd8'};

    const _gc = (name) => {

      const n = (name||'').toLowerCase();

      for (const [k,v] of Object.entries(_cm)) { if (n.includes(k)) return v; }

      return '#ccc';

    };

    const specsToShow = Object.entries(this.productSpecs);

    // Specifiche in stile card coerente con lo store
    gridEl.innerHTML = '';
    const table = document.createElement('div');
    table.className = 'fx-specs-table';
    table.style.cssText = 'font-family:var(--fx-font,Jost,sans-serif);background:#fff;border:1px solid var(--fx-border,#efefef);border-radius:12px;overflow:hidden';

    specsToShow.forEach(([key, spec], index) => {

      const tr = document.createElement('div');
      tr.className = 'fx-acc-item';
      const _accHeader = document.createElement('button');
      _accHeader.type = 'button';
      _accHeader.className = 'fx-acc-header';
      _accHeader.setAttribute('aria-expanded', 'false');

      _accHeader.innerHTML = `<span class="fx-acc-label">${spec.title}</span><svg class="fx-acc-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>`;
      const _accBody = document.createElement('div');
      _accBody.className = 'fx-acc-body';
      const _accInner = document.createElement('div');
      _accInner.className = 'fx-acc-inner';
      _accBody.appendChild(_accInner);

      const tdValue = _accInner;
      tdValue.style.cssText = 'font-size:0.875rem;font-weight:500;color:var(--fx-text,#2d3436);line-height:1.55';

      const valueEl = tdValue;

      // Rendering specifico per tipo

      if (key === 'formats') {

        // Pill/tag per ogni formato

        valueEl.classList.add('fx-spec-pillrow');

        const fmts = spec.value.split(',').map(f => f.trim()).filter(Boolean);

        valueEl.innerHTML = '<div style="display:flex;flex-wrap:wrap;gap:5px">' + fmts.map(f => `<span style="display:inline-block;padding:5px 12px;background:#f6f7f4;border:1px solid var(--fx-border,#e6e7e2);border-radius:var(--fx-radius,9px);font-size:0.78rem;font-weight:600;color:var(--fx-text,#4a4f56)">${f}</span>`).join('') + '</div>';

      } else if (key === 'colors') {

        // Color dots con immagini varianti o fallback colore - con wrap su mobile

        /* No classi extra — il flex è nel div wrapper dentro innerHTML */

        const colorList = spec.fullList && spec.fullList.length > 0 ? spec.fullList : spec.value.split(',').map(c => c.trim());

        const cImgs = spec.colorImages || {};

        const _dot = (c) => { const img = cImgs[c]; if (img) return `<span style="width:20px;height:20px;border-radius:50%;background:url(${img}) center/cover;border:1px solid rgba(0,0,0,0.12);flex-shrink:0"></span>`; const bg = _gc(c); return `<span style="width:20px;height:20px;border-radius:50%;background:${bg};border:1px solid rgba(0,0,0,0.12);flex-shrink:0"></span>`; };

        const showAll = colorList.length <= 12;

        const toShow = showAll ? colorList : colorList.slice(0, 10);

        valueEl.innerHTML = '<div style="display:flex;flex-wrap:wrap;gap:10px;align-items:center">' + toShow.map(c => `<span style="display:inline-flex;align-items:center;gap:5px">${_dot(c)}<span style="font-size:0.8rem">${c}</span></span>`).join('') + '</div>';

        if (!showAll) {

          const moreBtn = document.createElement('span');

          moreBtn.innerHTML = `<span style="display:inline-flex;align-items:center;gap:4px;margin:3px 0;font-size:0.8rem;color:var(--fx-primary);cursor:pointer;font-weight:600">+${colorList.length - 10} altri</span>`;

          moreBtn.addEventListener('click', () => {

            valueEl.innerHTML = colorList.map(c => `<span style="display:inline-flex;align-items:center;gap:6px;margin:4px 8px 4px 0;font-size:0.82rem;white-space:normal">${_dot(c)}${c}</span>`).join('');

          });

          valueEl.appendChild(moreBtn);

        }

      } else if (spec.isFormatTable && spec.rawData) {

        // Card dettagli per formato con icone SVG

        const boxIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:middle;margin-right:4px"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></svg>';

        const palIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:middle;margin-right:4px"><rect x="1" y="18" width="22" height="4" rx="1"/><rect x="3" y="8" width="18" height="10" rx="1"/><path d="M8 8V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3"/></svg>';

        let html = '<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(148px,1fr));gap:10px">';

        const _areaOf = (f) => { const s=String(f).toLowerCase(); if(s.includes('battiscopa')) return 1e12; const m=s.match(/([\d.,]+)\s*x\s*([\d.,]+)/); return m ? parseFloat(m[1].replace(',','.'))*parseFloat(m[2].replace(',','.')) : 1e11; };
        for (const [formato, details] of Object.entries(spec.rawData).sort((a,b)=>_areaOf(a[0])-_areaOf(b[0]))) {

          const _seenRows = new Set(); // KH-M5-DEDUP 2026-10-08: una card per formato ha solo box/pallet (non lo spessore) → entry con stesso formato ma spessore diverso rendono card identiche. Dedup sulla firma visibile.

          details.forEach(detail => {

            const isB = detail.is_battiscopa || detail.tipo === 'battiscopa' || formato.toLowerCase().includes('battiscopa') || /^[4-7][,.]?[0-9]*\s*x/i.test(formato);

            let bArea = isB && detail.ml_box != null ? `${String(detail.ml_box).replace('.', ',')} m lin.` : (detail.mq_box != null ? `${String(detail.mq_box).replace('.', ',')} m²` : '');

            const bKg = detail.kg_box != null ? `${String(Math.round(detail.kg_box*10)/10).replace('.', ',')} kg` : '';

            const bPz = detail.pezzi_box != null ? `${detail.pezzi_box} pz` : '';

            // KH-M5b 2026-10-08: battiscopa SENZA pezzi né metri lineari -> non mostrare il peso finto (19 kg placeholder), ma "Dati su richiesta".
            const bInfo = (isB && !bPz && !bArea) ? 'Dati su richiesta' : [bPz, bArea, bKg].filter(x=>x).join(' · ');

            const pBox = detail.box_pal != null ? `${detail.box_pal} box` : null;

            const pArea = isB && detail.ml_pal != null ? `${String(detail.ml_pal).replace('.', ',')} m lin.` : (detail.mq_pal != null ? `${String(detail.mq_pal).replace('.', ',')} m²` : null);

            const pKg = detail.kg_pal != null ? `${String(Math.round(detail.kg_pal*10)/10).replace('.', ',')} kg` : null;

            const pInfo = [pBox, pArea, pKg].filter(x=>x).join(' · ');

            // KH-M5 2026-10-08: etichetta SPESSORE per card (le "righe doppie" sono lo stesso formato in spessori diversi: vanno distinte, non collassate)
            const _spRaw = detail.spessore != null ? String(detail.spessore) : '';
            const _spMatch = _spRaw.match(/([\d]+[.,]?[\d]*)/);
            const _spRating = (_spRaw.match(/R\d+/i) || [''])[0];
            const spLabel = _spMatch ? (_spMatch[1].replace('.', ',') + ' mm' + (_spRating ? ' ' + _spRating.toUpperCase() : '')) : '';

            // dedup SOLO veri doppioni: stessa combinazione formato+spessore+box+pallet (spessori diversi NON vengono collassati)
            const _rowSig = (spLabel || '') + '||' + bInfo + '||' + pInfo;
            if (_seenRows.has(_rowSig)) return;
            _seenRows.add(_rowSig);

            const palRow = pInfo ? `<div style="display:flex;justify-content:space-between;gap:8px;padding:2px 0;border-top:1px solid var(--fx-border,#F5F2EB)"><span style="color:var(--fx-text)">${palIcon}Pallet</span><span style="font-weight:600;text-align:right">${pInfo}</span></div>` : '';

            html += `<div style="padding:12px 14px;background:#fff;border-radius:var(--fx-radius,10px);border:1px solid var(--fx-border,#ececec);box-shadow:0 1px 6px rgba(0,0,0,0.04)">
              <div style="font-weight:700;color:var(--fx-primary,#2D5A3D);margin-bottom:8px;font-size:0.85rem;padding-bottom:7px;border-bottom:1px solid var(--fx-border,#D9D2C5)">${String(formato).replace(/\./g,',')}${spLabel ? ` <span style="font-weight:600;font-size:0.72rem;color:var(--fx-text-muted,#9ca3af)">· ${spLabel}</span>` : ''}</div>
              <div style="font-size:0.74rem;line-height:1.5;color:var(--fx-text,#2d3436)">
                <div style="display:flex;justify-content:space-between;gap:8px;padding:2px 0"><span style="color:var(--fx-text)">${boxIcon}Box</span><span style="font-weight:600;text-align:right">${bInfo}</span></div>
                ${palRow}
              </div>
            </div>`;

          });

        }

        html += '</div>';

        valueEl.innerHTML = html;

      } else if (key === 'finishes') {

        // Pill tag per finiture

        valueEl.classList.add('fx-spec-pillrow');

        const fins = spec.value.split(',').map(f => f.trim()).filter(Boolean);

        valueEl.innerHTML = '<div style="display:flex;flex-wrap:wrap;gap:5px">' + fins.map(f => `<span style="display:inline-block;padding:5px 12px;background:#f6f7f4;border:1px solid var(--fx-border,#e6e7e2);border-radius:var(--fx-radius,9px);font-size:0.78rem;font-weight:600;color:var(--fx-text,#4a4f56)">${f}</span>`).join('') + '</div>';

      } else if (key === 'thickness') {

        // Pill tag per spessori

        valueEl.classList.add('fx-spec-pillrow');

        const thks = spec.value.split(',').map(t => t.trim()).filter(Boolean).map(t => t.replace(/\s*mm.*$/i,'').replace('.',',').trim() + ' mm');

        valueEl.innerHTML = '<div style="display:flex;flex-wrap:wrap;gap:5px">' + thks.map(t => `<span style="display:inline-block;padding:5px 12px;background:#f6f7f4;border:1px solid var(--fx-border,#e6e7e2);border-radius:var(--fx-radius,9px);font-size:0.78rem;font-weight:600;color:var(--fx-text,#4a4f56)">${t}</span>`).join('') + '</div>';

      } else if (key === 'outdoor' || key === 'speciali') {

        // Checkmark SVG verde + testo

        const chk = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2d5a3d" stroke-width="2.5" style="vertical-align:middle;margin-right:6px;flex-shrink:0"><path d="M20 6L9 17l-5-5"/></svg>';

        valueEl.innerHTML = `<span style="display:inline-flex;align-items:center;font-size:0.9rem;font-weight:600;color:#2d6a2e">${chk}${spec.value.replace(/^✓\s*/, '')}</span>`;

      } else if (key === 'material') {

        // Materiale evidenziato

        valueEl.innerHTML = spec.value;

      } else {

        // Testo standard con highlight

        if (spec.value.includes('Premium') || spec.value.includes('®')) {

          valueEl.innerHTML = spec.value.replace(/(Premium|®|™)/g, '<span style="color:var(--fx-primary);font-weight:700">$1</span>');

        } else {

          valueEl.innerHTML = `<span style="font-size:0.9rem">${spec.value}</span>`;

        }

      }

      tr.appendChild(_accHeader);
      tr.appendChild(_accBody);
      _accHeader.addEventListener('click', () => {
        const open = tr.classList.toggle('open');
        _accHeader.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          _accBody.style.maxHeight = _accInner.scrollHeight + 'px';
          const done = () => { if (tr.classList.contains('open')) _accBody.style.maxHeight = 'none'; _accBody.removeEventListener('transitionend', done); };
          _accBody.addEventListener('transitionend', done);
        } else {
          _accBody.style.maxHeight = _accInner.scrollHeight + 'px';
          requestAnimationFrame(() => requestAnimationFrame(() => { _accBody.style.maxHeight = '0px'; }));
        }
      });
      table.appendChild(tr);

    });

    gridEl.appendChild(table);

    // Nascondi loading

    if (loadingEl) {

      setTimeout(() => {

        loadingEl.style.display = 'none';

      }, 500);

    }

    this.specsLoadedInAccordion = true;

  }

  async analyzeProductAndGenerateSpecs() {

    const productTitle = this.product.title.toLowerCase();

    const productType = this.product.type?.toLowerCase() || '';

    const productTags = this.product.tags || [];

    const productCategory = this.identifyProductCategory(productTitle, productType, productTags);

    return this.generateSpecsForCategory(productCategory);

  }

  identifyProductCategory(title, type, tags) {

    const categories = {

      tile: ['piastrella', 'tile', 'pavimento', 'rivestimento', 'gres', 'porcellanato', 'ceramica', 'floor', 'wall'],

      outdoor: ['outdoor', 'esterno', 'esterni', 'terrazzo', 'giardino', 'piscina', 'antiscivolo'],

      bathroom: ['bagno', 'bathroom', 'doccia', 'shower'],

      kitchen: ['cucina', 'kitchen'],

      living: ['soggiorno', 'living', 'sala', 'salotto']

    };

    for (const [category, keywords] of Object.entries(categories)) {

      if (keywords.some(keyword => title.includes(keyword) || type.includes(keyword))) {

        return category;

      }

    }

    for (const tag of tags) {

      const tagLower = tag.toLowerCase();

      for (const [category, keywords] of Object.entries(categories)) {

        if (keywords.some(keyword => tagLower.includes(keyword))) {

          return category;

        }

      }

    }

    // Default per Ceramica Euro: piastrelle

    return 'tile';

  }

  generateSpecsForCategory(category) {

    if (!this.ceramicaEuroSpecs) {

      // Carica i valori di default dal JSON

      return {

        tile: {

          title: 'Specifiche Tecniche Ceramica',

          specs: {

            'Formati': '60×60 cm, 30×60 cm',

            'Spessore': '9 mm',

            'Materiale': 'Gres porcellanato smaltato',

            'Finiture': 'R10, V2 variazione colore, Naturale',

            'Installazione': 'Centro stanza/Parete',

            'Accessori': 'Scarico, piletta, sifone',

            'Garanzia': '24 mesi (garanzia legale)',

            'Certificazioni': 'Conforme normative CE'

          }

        }

      }[category] || { title: 'Specifiche Tecniche', specs: {} };

    }

    const productTitle = (this.product.title || '').toUpperCase();

    const variantTitle = this.currentVariant ? (this.currentVariant.title || '').toUpperCase() : '';

    const productVendor = (this.product.vendor || '').toUpperCase();

    const normalizeForMatch = (str) => {

      if (!str) return '';

      return str

        /* KH-FIX 2026-10-08: NON prende più solo "prima del trattino" (era il VENDOR!). Normalizza l'intera stringa; il vendor viene tolto a parte in productNorm. */

        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')  // Rimuove accenti (Ê→E, È→E, etc.)

        .toLowerCase()

        .replace(/æ/g, 'ae')

        .replace(/œ/g, 'oe')

        .replace(/t_20/g, 't20')

        .replace(/[^a-z0-9]/g, '')

        .replace(/\s+/g, '');

    };

    /* KH-FIX 2026-10-08: togli il VENDOR (tutto fino al 1° trattino) -> resta il MODELLO. Così pass1 fa match esatto (es. "arkigem"==="arkigem") e nomi corti tipo "ORO" non cascano dentro il vendor ("marcacorona"). */
    const productNorm = normalizeForMatch(String(this.product.title || '').replace(/^[^-–—]*[-–—]\s*/, ''));

    let modelSpecs = null;

    if (this.ceramicaEuroSpecs && this.ceramicaEuroSpecs.length > 0) {

      const normalizeVendor = (str) => {

        if (!str) return '';

        return str.toUpperCase().replace(/[^A-Z0-9]/g, '').trim();

      };

      const vendorNorm = normalizeVendor(productVendor);

      let filteredCollezioni = this.ceramicaEuroSpecs.filter(collezione => {

        const collezioneProduttore = normalizeVendor(collezione.produttore || collezione.vendor || '');

        if (!vendorNorm) return true;

        if (!collezioneProduttore) return true;

        return vendorNorm.includes(collezioneProduttore) || collezioneProduttore.includes(vendorNorm);

      });

      if (filteredCollezioni.length === 0) filteredCollezioni = this.ceramicaEuroSpecs;

      let foundCollezione = null;

      for (const collezione of filteredCollezioni) {

        const collezioneNorm = normalizeForMatch(collezione.nome);

        if (collezioneNorm === productNorm) {

          foundCollezione = collezione;

          break;

        }

      }

      if (!foundCollezione) {

        for (const collezione of filteredCollezioni) {

          const collezioneNorm = normalizeForMatch(collezione.nome);

          // Evita match troppo corti

          if (collezioneNorm.length < 3) continue;

          if (productNorm.includes(collezioneNorm) || collezioneNorm.includes(productNorm)) {

            foundCollezione = collezione;

            break;

          }

        }

      }

      if (!foundCollezione) {

        // KH-FIX 2026-10-08: match SOLO sul titolo PRODOTTO (non variante, che contiene il COLORE es. "Bianco"
        // -> agganciava la collezione "BIANCO" invece di EVOQ) e scegli il nome PIÙ LUNGO/specifico
        // (evita che "LOG"⊂GEOLOGY, "ART"⊂ARTISTIC STONE, "VEST"⊂RIVESTIMENTI, "VIS"⊂TREVISTONE vincano sul giusto).
        let _bestLen = 0;

        for (const collezione of filteredCollezioni) {

          const nomeCollezione = collezione.nome.toUpperCase();

          if (nomeCollezione.length < 3) continue;

          if (productTitle.includes(nomeCollezione) && nomeCollezione.length > _bestLen) {

            _bestLen = nomeCollezione.length;

            foundCollezione = collezione;

          }

        }

      }


      if (foundCollezione) {

        try { var _t20b = normalizeForMatch(foundCollezione.nome); var _t20c = filteredCollezioni.find(function(c){ return c !== foundCollezione && normalizeForMatch(c.nome) === _t20b + 't20'; }); if (_t20c && Array.isArray(_t20c.varianti) && _t20c.varianti.length) { foundCollezione = Object.assign({}, foundCollezione, { varianti: foundCollezione.varianti.concat(_t20c.varianti) }); } } catch(e){}

        const collezione = foundCollezione;

        if (collezione.varianti && collezione.varianti.length > 0) {

            const aggregatedData = {

              formati: new Set(),

              spessori: new Set(),

              finiture: new Set(),

              codici: new Set(),

              coloriFromShopify: new Set(),

              pezzi_box_values: new Set(),

              mq_box_values: new Set(),

              kg_box_values: new Set(),

              box_pal_values: new Set(),

              mq_pal_values: new Set(),

              kg_pal_values: new Set(),

              outdoor: false,

              speciali: false

            };

            const formatDetails = {};

            // PASSO 1: Estrai dati DA JSON (indicizzati per formato+spessore)

            const jsonDataByKey = {}; // Mappa "formato|spessore" → dati JSON


            collezione.varianti.forEach((variante, idx) => {

              let fmt = variante.formato;

              if (!fmt) return;

              // Normalizza formato: rimuovi "(Battiscopa)", sostituisci virgola con punto

              fmt = fmt.replace(/\s*\(Battiscopa\)/gi, '').replace(/,/g, '.').trim();

              const spess = (variante.spessore || '').replace(/\s+/g, '').replace(',', '.'); // Rimuovi spazi + virgola->punto (fix 8,5mm)

              const key = `${fmt}|${spess}`;


              const varData = {

                pezzi_box: variante.pezzi_box,

                kg_box: variante.kg_box,

                mq_box: variante.mq_box,

                box_pal: variante.box_pal,

                mq_pal: variante.mq_pal,

                speciali: variante.speciali,

                ml_box: variante.ml_box,

                ml_pal: variante.ml_pal,

                kg_pal: variante.kg_pal,

                is_battiscopa: variante.is_battiscopa || /battiscopa/i.test(variante.formato || '')

              };

              if (!jsonDataByKey[key]) jsonDataByKey[key] = []; jsonDataByKey[key].push(varData);

              // Alias senza rating (es. "60x60|20mmR11" -> anche "60x60|20mm")
              const spessBase = spess.replace(/r\d+/gi, '');
              if (spessBase !== spess) {
                if (!jsonDataByKey[`${fmt}|${spessBase}`]) jsonDataByKey[`${fmt}|${spessBase}`] = [];
                jsonDataByKey[`${fmt}|${spessBase}`].push(varData);
              }

              if (variante.pezzi_box) aggregatedData.pezzi_box_values.add(variante.pezzi_box);

              if (variante.mq_box) aggregatedData.mq_box_values.add(variante.mq_box);

              if (variante.box_pal) aggregatedData.box_pal_values.add(variante.box_pal);

              if (variante.mq_pal) aggregatedData.mq_pal_values.add(variante.mq_pal);

              if (variante.outdoor) aggregatedData.outdoor = true;

              if (variante.speciali) aggregatedData.speciali = true;

            });

            // PASSO 2: Estrai formati, spessori, finiture, colori, SKU dalle varianti Shopify

            if (this.product.variants && this.product.variants.length > 0) {

              const fmtPat = /(\d+(?:[,\.]\d+)?)\s*[x×X]\s*(\d+(?:[,\.]\d+)?)/i;

              const formatDataMap = {}; // Raggruppa per "formato|spessore"

              this.product.variants.forEach((shopifyVariant, index) => {

                // DEBUG: mostra prima variante

                if (index === 0) {


                }

                // Estrai formato

                let formato = null;

                [shopifyVariant.option1, shopifyVariant.option2, shopifyVariant.option3].forEach(opt => {

                  if (opt && fmtPat.test(opt) && !formato) {

                    const match = opt.match(fmtPat);

                    if (match) {

                      formato = `${match[1].replace(',','.')}x${match[2].replace(',','.')}`;

                    }

                  }

                });

                // Estrai spessore (es. "6 mm", "9mm", "20 mm R9", "20 mm R11")

                let spessore = '';

                const spessoreMatch = shopifyVariant.option3 || shopifyVariant.title;

                if (spessoreMatch && /\d+\s*mm/i.test(spessoreMatch)) {

                  // Cattura anche R9/R10/R11 dopo mm

                  const match = spessoreMatch.match(/(\d+(?:[,\.]\d+)?)\s*mm(?:\s*R\d+)?/i);

                  if (match) {

                    // Usa solo gruppo 1 (numero) + "mm" per raggruppare R9/R10/R11

                    spessore = match[1].replace(',', '.') + 'mm';

                    // Normalizza spessore rimuovendo spazi (già senza R9/R11)

                    aggregatedData.spessori.add(spessore.replace(/\s+/g, ''));

                  }

                }

                // Estrai colore (normalmente option2)

                if (shopifyVariant.option2) {

                  aggregatedData.coloriFromShopify.add(shopifyVariant.option2);

                }

                // Estrai finitura (dalle opzioni o titolo)

                const finitureKeywords = ['Naturale', 'Lappata', 'Lappato', 'Satinata', 'Satinato',

                                         'Grip', 'Antislip', 'R9', 'R10', 'R11', 'Fade', 'RealUp', 'StrideUp',

                                         'Matte', 'Silk', 'Lucida', 'Lucido', 'Opaco', 'Velvet', 'Hammered', 'Glossy', 'Strutturato', 'Outdoor'];

                const optText = [shopifyVariant.option1, shopifyVariant.title].join(' ');

                finitureKeywords.forEach(keyword => {

                  if (new RegExp(keyword, 'i').test(optText)) {

                    aggregatedData.finiture.add(keyword);

                  }

                });

                // Estrai SKU

                if (shopifyVariant.sku) {

                  aggregatedData.codici.add(shopifyVariant.sku);

                }

                // Raccogli dati per ogni variante (SENZA raggruppare per forza)

                if (formato) {

                  aggregatedData.formati.add(formato);

                  const spessoreNorm = spessore.replace(/\s+/g, ''); // Normalizza spessore (rimuovi spazi)

                  const pesoBoxKg = shopifyVariant.weight ? (shopifyVariant.weight / 1000) : null;

                  if (pesoBoxKg) {

                    aggregatedData.kg_box_values.add(pesoBoxKg);

                  }

                  // Cerca i dati nel JSON usando formato|spessore
                  // Fallback: prova senza rating (es. "20mmR11" -> "20mm")

                  let jsonKey = `${formato}|${spessoreNorm}`;

                  let jsonArr = jsonDataByKey[jsonKey] || [];
                  if (!jsonArr.length) {
                    const spessoreBase = spessoreNorm.replace(/r\d+/gi, '');
                    const jsonKey2 = `${formato}|${spessoreBase}`;
                    jsonArr = jsonDataByKey[jsonKey2] || [];
                    jsonKey = jsonKey2;
                  }
                  // KH-BATTI-MATCH 2026-10-08: battiscopa con formato specs non coincidente (es. variante 6x61 vs specs 7x60)
                  // -> nessun match: cerca un'entry battiscopa nelle specs con il LATO LUNGO simile (±3 cm). Evita il fallback "10 pz / 19 kg".
                  if (!jsonArr.length && /battiscopa/i.test(shopifyVariant.option1 || '')) {
                    const _bd = String(formato).split('x').map(parseFloat);
                    const _blen = Math.max(_bd[0] || 0, _bd[1] || 0);
                    let _best = null, _bestDiff = Infinity;
                    Object.keys(jsonDataByKey).forEach(k => {
                      jsonDataByKey[k].forEach(d => {
                        if (!d.is_battiscopa) return;
                        const _kd = k.split('|')[0].split('x').map(parseFloat);
                        const _kl = Math.max(_kd[0] || 0, _kd[1] || 0);
                        const _diff = Math.abs(_kl - _blen);
                        if (_diff <= 3 && _diff < _bestDiff) { _bestDiff = _diff; _best = d; }
                      });
                    });
                    if (_best) jsonArr = [_best];
                  }
                  let jsonData = {};
                  if (jsonArr.length === 1) { jsonData = jsonArr[0]; }
                  else if (jsonArr.length > 1) {
                    jsonData = jsonArr[0];
                    if (pesoBoxKg != null) {
                      let bestDiff = Infinity;
                      jsonArr.forEach(c => {
                        if (c.kg_box != null) {
                          const diff = Math.abs(c.kg_box - pesoBoxKg);
                          if (diff < bestDiff) { bestDiff = diff; jsonData = c; }
                        }
                      });
                    }
                  }

                  // KH-BATTI-ML 2026-10-08: i BATTISCOPA si misurano in METRI LINEARI, non m². Se l'entry non ha ml_box
                  // (o ha erroneamente mq_box, es. MUSE), calcolo ml = pezzi × lato_lungo/100 e azzero i m². Clono per non alterare la condivisa.
                  if (jsonData && (jsonData.is_battiscopa || /battiscopa/i.test(shopifyVariant.option1 || ''))) {
                    const _md = String(formato).split('x').map(parseFloat);
                    const _mlen = Math.max(_md[0] || 0, _md[1] || 0);
                    // KH-BATTI-DADO 2026-10-09: i battiscopa DADO senza dato pezzi -> scatola standard 20 pz per i formati lunghi ~60 cm
                    // (7x60 / 6x61 / 7x62), verificato dal catalogo Dado 2026. NON universale (es. Imola 6x60 = 15 pz) -> solo vendor DADO.
                    let _pzb = jsonData.pezzi_box;
                    if (!_pzb) {
                      const _vd = ((window.KH_PROD && window.KH_PROD.vendor) || '').toUpperCase();
                      const _mshort = Math.min(_md[0] || 0, _md[1] || 0);
                      if (_vd.indexOf('DADO') >= 0) {
                        if (_mlen >= 59 && _mlen <= 63) _pzb = 20;                               // 7x60 / 6x61 / 7x62
                        else if (_mlen >= 30 && _mlen <= 32 && _mshort >= 7.3 && _mshort <= 7.7) _pzb = 46; // 7,5x31 (TAVELLONE/SASSONE)
                      }
                    }
                    // metri lineari ACCURATI = pezzi × lato_lungo/100 (es. IKON 20×0,61 = 12,2). Forza is_battiscopa (per __KH_BATTI__) e azzera i m².
                    const _nml = (_pzb && _mlen) ? Math.round(_pzb * _mlen) / 100 : jsonData.ml_box;
                    jsonData = Object.assign({}, jsonData, { is_battiscopa: true, pezzi_box: _pzb, mq_box: null, mq_pal: null, ml_box: _nml });
                    if (jsonData.box_pal && _nml != null) jsonData.ml_pal = Math.round(_nml * jsonData.box_pal * 100) / 100;
                  }
                  // KH-MQBOX 2026-10-08: per i TILE allinea la tabella "Dettagli per formato" al CONFIGURATORE ->
                  // mq/scatola = prezzo / €m² (misura-unità Shopify nativa). Elimina le discrepanze ×2/×½ tra tabella e configuratore.
                  else if (jsonData) {
                    try {
                      const _upm = (window.__KH_UNIT__ || {})[shopifyVariant.id];
                      const _unit = _upm && _upm.p; const _pr = shopifyVariant.price;
                      const _am = String(formato).split('x').map(parseFloat);
                      const _geoArea = (_am[0] && _am[1]) ? (_am[0] / 100) * (_am[1] / 100) : 0;
                      // KH-PZAREA 2026-10-09: area per pezzo REALE dalla spec (mq_box/pezzi_box) se presente -> gestisce i
                      // formati modulari/brick con fuga (es. BRICKONE 7,4x31 reale 34pz, non 40 geometrici). Altrimenti geometrica.
                      const _area = (jsonData.pezzi_box && jsonData.mq_box) ? (jsonData.mq_box / jsonData.pezzi_box) : _geoArea;
                      if (_unit && _pr && _area) {
                        const _boxMq = Math.round((_pr / _unit) * 100) / 100;
                        if (_boxMq >= 0.05 && _boxMq <= 20) {
                          const _pz = Math.max(1, Math.round(_boxMq / _area));
                          jsonData = Object.assign({}, jsonData, { mq_box: _boxMq, pezzi_box: _pz });
                          if (jsonData.box_pal) jsonData.mq_pal = Math.round(_boxMq * jsonData.box_pal * 100) / 100;
                        }
                      }
                    } catch (e) {}
                  }

                  if (index === 0) {


                  }

                  // Crea una chiave unica per questa combinazione (formato+spessore+peso+pezzi)

                  // per evitare di raggruppare varianti con pesi/pezzi diversi

                  // IMPORTANTE: rimuovi R9/R10/R11 dallo spessore per raggruppare varianti con stessa resistenza

                  const spessoreBase = spessoreNorm.replace(/\s*R\d+/gi, '').trim(); // Rimuove R9, R10, R11

                  const uniqueKey = `${formato}|${spessoreBase}|${jsonData.pezzi_box || 0}`;

                  if (!formatDataMap[uniqueKey]) {

                    formatDataMap[uniqueKey] = {

                      formato: formato,

                      spessore: spessoreBase || spessore, // Usa spessoreBase normalizzato, fallback su originale

                      pesoBoxKg: pesoBoxKg,

                      jsonData: jsonData

                    };

                  }

                }

              });

              // PASSO 3: Crea formatDetails (una entry per ogni combinazione unica)


              for (const [uniqueKey, shopifyData] of Object.entries(formatDataMap)) {

                const formato = shopifyData.formato;

                const pesoBoxKg = shopifyData.pesoBoxKg;

                const jsonData = shopifyData.jsonData;



                // Calcola kg_pal = peso_box_kg * box_pal

                const kgPal = (pesoBoxKg && jsonData.box_pal) ?

                  Math.round(pesoBoxKg * jsonData.box_pal * 100) / 100 : null;


                if (kgPal) {

                  aggregatedData.kg_pal_values.add(kgPal);

                }

                if (!formatDetails[formato]) {

                  formatDetails[formato] = [];

                }

                const detailEntry = {

                  spessore: shopifyData.spessore,

                  mq_box: jsonData.mq_box,

                  kg_box: pesoBoxKg,

                  pezzi_box: jsonData.pezzi_box,

                  box_pal: jsonData.box_pal,

                  mq_pal: jsonData.mq_pal,

                  kg_pal: kgPal,

                  finitura: aggregatedData.finiture.size > 0 ? Array.from(aggregatedData.finiture).join(', ') : '',

                  ml_box: jsonData.ml_box,

                  ml_pal: jsonData.ml_pal,

                  is_battiscopa: jsonData.is_battiscopa

                };


                formatDetails[formato].push(detailEntry);

                /* KH-BATTI-PZ 2026-10-07: mappa size->{pezzi_box,kg_box} per i BATTISCOPA del prodotto corrente, letta dal configuratore (kh-config-v3) per mostrare pezzi/scatola e peso REALI invece del "10" fisso e dei grammi segnaposto. */
                try {
                  if (detailEntry.is_battiscopa && detailEntry.pezzi_box) {
                    var _kbSize = String(formato).replace(/\s*\(.*?\)/g, '').replace(/,/g, '.').replace(/×/g, 'x').replace(/\s+/g, '').toLowerCase();
                    window.__KH_BATTI__ = window.__KH_BATTI__ || {};
                    window.__KH_BATTI__[_kbSize] = { pz: detailEntry.pezzi_box, kg: detailEntry.kg_box };
                    if (!window.__khBattiDispatched) { window.__khBattiDispatched = true; setTimeout(function () { try { document.dispatchEvent(new CustomEvent('kh:batti-ready')); } catch (e) {} }, 0); }
                  }
                } catch (e) {}

              }

            }

            // Colori sempre da Shopify

            const finalColors = Array.from(aggregatedData.coloriFromShopify);

            modelSpecs = {

              codici: Array.from(aggregatedData.codici),

              formati: Array.from(aggregatedData.formati),

              spessori: Array.from(aggregatedData.spessori).sort((a,b)=>(parseFloat(String(a).replace(',','.'))||0)-(parseFloat(String(b).replace(',','.'))||0)),

              materiale: 'Gres porcellanato' + (aggregatedData.outdoor ? ' per esterni' : ''),

              colori: finalColors,

              finiture: Array.from(aggregatedData.finiture),

              // Dettagli per formato

              formatDetails: formatDetails,

              pezzi_box_values: aggregatedData.pezzi_box_values,

              mq_box_values: aggregatedData.mq_box_values,

              kg_box_values: aggregatedData.kg_box_values,

              box_pal_values: aggregatedData.box_pal_values,

              mq_pal_values: aggregatedData.mq_pal_values,

              kg_pal_values: aggregatedData.kg_pal_values,

              pezzi_box: Array.from(aggregatedData.pezzi_box_values)[0] || 4,

              mq_box: Array.from(aggregatedData.mq_box_values)[0] || 1.44,

              kg_box: Array.from(aggregatedData.kg_box_values)[0] || 28.80,

              box_pal: Array.from(aggregatedData.box_pal_values)[0] || 36,

              mq_pal: Array.from(aggregatedData.mq_pal_values)[0] || 51.84,

              kg_pal: Array.from(aggregatedData.kg_pal_values)[0] || 1036.80,

              outdoor: aggregatedData.outdoor,

              speciali: aggregatedData.speciali

            };

        }

      }

    }

    // Usa default se non trova niente

    if (!modelSpecs) {

      modelSpecs = {

        codici: ['STD-001'],

        formati: ['60×60', '30×60'],

        spessori: ['9mm'],

        materiale: 'Gres porcellanato smaltato',

        colori: ['Grigio', 'Beige', 'Bianco'],

        finiture: ['R10'],

        pezzi_box: 4,

        mq_box: 1.44,

        kg_box: 28.80,

        box_pal: 36,

        mq_pal: 51.84,

        kg_pal: 1036.80

      };

    }

    let formatsList = [];

    if (this.product.variants && this.product.variants.length > 0) {

      const formats = new Map();

      const fmtPat = /(\d+(?:[,\.]\d+)?)\s*[x×X]\s*(\d+(?:[,\.]\d+)?)/gi;

      this.product.variants.forEach(variant => {

        let found = false;

        [variant.option1, variant.option2, variant.option3].forEach(option => {

          if (option && !found) {

            for (const m of option.matchAll(fmtPat)) {

              const w = parseFloat(m[1].replace(',','.')), h = parseFloat(m[2].replace(',','.'));

              const k = `${w%1===0?w:w}×${h%1===0?h:h}`;

              formats.set(k, {width:w,height:h,display:k}); found=true; break;

            }

          }

        });

        if (!found && variant.title) {

          for (const m of variant.title.matchAll(fmtPat)) {

            const w = parseFloat(m[1].replace(',','.')), h = parseFloat(m[2].replace(',','.'));

            const k = `${w%1===0?w:w}×${h%1===0?h:h}`;

            formats.set(k, {width:w,height:h,display:k}); break;

          }

        }

      });

      formatsList = Array.from(formats.values())

        .sort((a,b) => (b.width*b.height)-(a.width*a.height) || b.width-a.width || b.height-a.height)

        .map(f => f.display);

    }

    if (formatsList.length === 0 && modelSpecs.formati && modelSpecs.formati.length > 0) formatsList = modelSpecs.formati;

    if (formatsList.length === 0) formatsList = ['60×60', '30×60'];

    const ceramicaSpecs = {

      thickness: {

        title: 'Spessore',

        value: (modelSpecs.spessori && modelSpecs.spessori.length > 0) ? [...new Set(modelSpecs.spessori)].join(', ') : '9mm',

        enrichable: false

      },

      material: {

        title: 'Materiale',

        value: modelSpecs.materiale || 'Gres porcellanato smaltato',

        enrichable: false

      },

      colors: {

        title: 'Colori Disponibili',

        value: modelSpecs.colori ? (Array.isArray(modelSpecs.colori) ?

          (modelSpecs.colori.length <= 6 ? modelSpecs.colori.join(', ') :

           modelSpecs.colori.slice(0, 6).join(', ') + ` (+${modelSpecs.colori.length - 6} altri)`) : modelSpecs.colori) : 'Grigio, Beige, Bianco',

        enrichable: false,

        fullList: modelSpecs.colori || [],

        count: modelSpecs.colori ? modelSpecs.colori.length : 0,

        colorImages: (() => { const m = {}; if (this.product.variants) { this.product.variants.forEach(v => { const c = v.option2; if (c && !m[c] && v.featured_image) m[c] = v.featured_image.src.replace(/(\.\w+)\?/, '_100x100$1?'); }); } return m; })()

      },

      finishes: {

        title: 'Finiture',

        value: modelSpecs.finiture ? (Array.isArray(modelSpecs.finiture) ? [...new Set(modelSpecs.finiture)].join(', ') : modelSpecs.finiture) : 'R10, Naturale',

        enrichable: false

      }

    };

    if (modelSpecs.formatDetails && Object.keys(modelSpecs.formatDetails).length > 0) {

      let detailsString = '';

      for (const [formato, details] of Object.entries(modelSpecs.formatDetails)) {

        details.forEach(detail => {

          const isBattiscopa = detail.is_battiscopa || detail.tipo === 'battiscopa' ||

                               formato.toLowerCase().includes('battiscopa') ||

                               /^[4-7][,.]?[0-9]*\s*x/i.test(formato);

          let boxArea = 'N/D';

          if (isBattiscopa && detail.ml_box != null) {

            boxArea = `${String(detail.ml_box).replace('.', ',')} m lin.`;

          } else if (detail.mq_box != null) {

            boxArea = `${String(detail.mq_box).replace('.', ',')} m²`;

          }

          const boxKg = detail.kg_box != null ? `${String(Math.round(detail.kg_box*10)/10).replace('.', ',')} kg` : '';

          const boxPz = detail.pezzi_box != null ? `${detail.pezzi_box} pz` : '';

          const boxInfo = [boxArea, boxKg, boxPz].filter(x => x).join(', ');

          const palletBox = detail.box_pal != null ? `${detail.box_pal} box` : null;

          const palletArea = isBattiscopa && detail.ml_pal != null ? `${String(detail.ml_pal).replace('.', ',')} m lin.` :

                             (detail.mq_pal != null ? `${String(detail.mq_pal).replace('.', ',')} m²` : null);

          const palletKg = detail.kg_pal != null ? `${String(Math.round(detail.kg_pal*10)/10).replace('.', ',')} kg` : null;

          const palletInfo = [palletBox, palletArea, palletKg].filter(x => x).join(', ') || 'N/D';

          detailsString += `${formato}:\n`;

          detailsString += `  Box: ${boxInfo}\n`;

          detailsString += `  Pallet: ${palletInfo}\n`;

        });

      }

      ceramicaSpecs.formatDetails = {

        title: 'Dettagli per Formato',

        value: detailsString.trim() || 'Dettagli disponibili',

        enrichable: false,

        isFormatTable: true,

        rawData: modelSpecs.formatDetails

      };

    }

    if (modelSpecs.outdoor) {

      ceramicaSpecs.outdoor = {

        title: 'Uso Esterno',

        value: '✓ Adatto per esterni',

        enrichable: false

      };

    }

    if (modelSpecs.speciali) {

      ceramicaSpecs.speciali = {

        title: 'Pezzi Speciali',

        value: '✓ Disponibili pezzi speciali',

        enrichable: false

      };

    }

    return ceramicaSpecs;

  }

  initializeCarousel() {

    // Get product images

    this.images = this.product.images || [];

    // If no images, create placeholder

    if (this.images.length === 0) {

      this.images = [{

        url: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='600'%3E%3Crect width='100%25' height='100%25' fill='%23f8f9fa'/%3E%3C/svg%3E`,

        alt: this.product.title

      }];

    }

    // Initialize with first image

    this.currentImageIndex = 0;

    this.currentZoomIndex = 0;

    // Create carousel HTML structure

    this.createCarouselStructure();

    // Setup carousel controls

    this.setupCarouselControls();

    this.updateCarousel();

  }

  createCarouselStructure() {

    // Crea struttura per entrambi i caroselli (desktop e mobile)

    const desktopTrack = document.querySelector('.fx-carousel-desktop .fx-carousel-track');

    const mobileTrack = document.querySelector('.fx-carousel-mobile .fx-carousel-track');

    // Create desktop carousel

    if (desktopTrack) {

      desktopTrack.innerHTML = '';

      this.images.forEach((imageData, index) => {

        const item = document.createElement('div');

        item.className = 'fx-carousel-item';

        // Set initial class for desktop

        if (index === 0) {

          item.classList.add('fx-item-current');

        } else if (index === 1 && this.images.length > 1) {

          item.classList.add('fx-item-next');

        } else if (index === this.images.length - 1 && this.images.length > 2) {

          item.classList.add('fx-item-prev');

        }

        const img = document.createElement('img');

        img.loading = 'lazy';

        // Set image source

        const imageUrl = imageData.url || imageData.src || imageData;

        if (imageUrl) {

          img.src = this.getShopifyImageUrl(imageUrl, '1200x1200');

          img.alt = imageData.alt || this.product.title;

          // Add zoom on click for current image

        }

        item.appendChild(img);

        desktopTrack.appendChild(item);

      });

    }

    // Create mobile carousel

    if (mobileTrack) {

      mobileTrack.innerHTML = '';

      this.images.forEach((imageData, index) => {

        const item = document.createElement('div');

        item.className = 'fx-carousel-item';

        // Set initial class for mobile - only first is current

        if (index === 0) {

          item.classList.add('fx-item-current');

        }

        const img = document.createElement('img');

        img.loading = 'lazy';

        // Set image source

        const imageUrl = imageData.url || imageData.src || imageData;

        if (imageUrl) {

          img.src = this.getShopifyImageUrl(imageUrl, '800x800');

          img.alt = imageData.alt || this.product.title;

        }

        item.appendChild(img);

        mobileTrack.appendChild(item);

      });

    }

  }

  setupCarouselControls() {

    // Setup dots dynamically

    this.setupCarouselDots();

    // Setup image click navigation

    this.setupImageClickNavigation();

    // Touch controls

    this.setupTouchControls();

    // Auto-rotate (optional)

    this.startAutoRotate();

  }

  setupImageClickNavigation() {

    // Add click listeners to both carousel items

    const carousels = [

      document.getElementById('fxProductCarousel'),

      document.getElementById('fxProductCarouselMobile')

    ];

    carousels.forEach(carousel => {

      if (!carousel) return;

      carousel.addEventListener('click', (e) => {

        const clickedItem = e.target.closest('.fx-carousel-item');

        if (!clickedItem || this.images.length <= 1) return;

        // Determine which image was clicked

        if (clickedItem.classList.contains('fx-item-prev')) {

          this.prevImage();

        } else if (clickedItem.classList.contains('fx-item-next')) {

          this.nextImage();

        }

      });

    });

  }

  setupCarouselDots() {

    // Setup dots per entrambi i caroselli

    const dotsContainers = document.querySelectorAll('.fx-carousel-dots');

    dotsContainers.forEach(dotsContainer => {

      if (!dotsContainer) return;

      // Clear existing dots

      dotsContainer.innerHTML = '';

      // Create dots based on actual number of images

      this.images.forEach((_, index) => {

        const dot = document.createElement('span');

        dot.className = `fx-dot ${index === this.currentImageIndex ? 'active' : ''}`;

        dot.setAttribute('data-index', index);

        dot.addEventListener('click', () => this.goToImage(index));

        dotsContainer.appendChild(dot);

      });

    });

  }

  setupTouchControls() {

    // Setup touch controls per entrambi i caroselli

    const carousels = [

      document.getElementById('fxProductCarousel'),

      document.getElementById('fxProductCarouselMobile')

    ];

    carousels.forEach(carousel => {

      if (!carousel) return;

      let startX = 0;

      let startY = 0;

      let endX = 0;

      let endY = 0;

      let isSwiping = false;

      let currentX = 0;

      // Touch start

      carousel.addEventListener('touchstart', (e) => {

        startX = e.touches[0].clientX;

        startY = e.touches[0].clientY;

        isSwiping = true;

        // Aggiungi classe per disabilitare transizioni durante swipe

        carousel.classList.add('swiping');

      }, { passive: true });

      // Touch move - per feedback visivo opzionale

      carousel.addEventListener('touchmove', (e) => {

        if (!isSwiping) return;

        currentX = e.touches[0].clientX;

        const currentY = e.touches[0].clientY;

        const diffX = startX - currentX;

        const diffY = startY - currentY;

        // Se il movimento verticale è maggiore, ignora lo swipe orizzontale

        if (Math.abs(diffY) > Math.abs(diffX)) {

          isSwiping = false;

          return;

        }

        // Previeni scroll verticale durante swipe orizzontale

        if (Math.abs(diffX) > 10) {

          e.preventDefault();

        }

      }, { passive: false });

      // Touch end

      carousel.addEventListener('touchend', (e) => {

        if (!isSwiping) {

          carousel.classList.remove('swiping');

          return;

        }

        endX = e.changedTouches[0].clientX;

        endY = e.changedTouches[0].clientY;

        const diffX = startX - endX;

        const diffY = startY - endY;

        // Rimuovi classe swiping

        carousel.classList.remove('swiping');

        // Calcola se è uno swipe valido (più orizzontale che verticale)

        if (Math.abs(diffX) > Math.abs(diffY)) {

          // Soglia minima per swipe: 30px su mobile, 50px su desktop

          const threshold = window.innerWidth <= 768 ? 30 : 50;

          if (Math.abs(diffX) > threshold) {

            if (diffX > 0) {

              // Swipe sinistro - immagine successiva

              this.nextImage();

            } else {

              // Swipe destro - immagine precedente

              this.prevImage();

            }

          }

        }

        isSwiping = false;

      }, { passive: true });

      // Touch cancel - gestisce interruzioni

      carousel.addEventListener('touchcancel', () => {

        isSwiping = false;

        carousel.classList.remove('swiping');

      }, { passive: true });

    });

  }

  startAutoRotate() {

    if (this.images.length <= 1) return;

    // Clear any existing interval

    if (this.autoRotateInterval) {

      clearInterval(this.autoRotateInterval);

    }

    this.autoRotateInterval = setInterval(() => {

      // Only auto-rotate if user isn't interacting and there are multiple images

      if (!this.userInteracting && this.images.length > 1) {

        this.nextImage();

      }

    }, 5000); // Rotazione automatica ogni 5 secondi

  }

  prevImage() {

    if (this.images.length <= 1) return;

    this.userInteracting = true;

    this.currentImageIndex = (this.currentImageIndex - 1 + this.images.length) % this.images.length;

    this.updateCarousel();

    setTimeout(() => {

      this.userInteracting = false;

    }, 3000);

  }

  nextImage() {

    if (this.images.length <= 1) return;

    this.userInteracting = true;

    this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;

    this.updateCarousel();

    setTimeout(() => {

      this.userInteracting = false;

    }, 3000);

  }

  goToImage(index) {

    if (index < 0 || index >= this.images.length || index === this.currentImageIndex) return;

    this.userInteracting = true;

    this.currentImageIndex = index;

    this.updateCarousel();

    setTimeout(() => {

      this.userInteracting = false;

    }, 3000);

  }

  updateCarousel() {

    // Aggiorna entrambi i caroselli (desktop e mobile)

    const desktopItems = document.querySelectorAll('.fx-carousel-desktop .fx-carousel-item');

    const mobileItems = document.querySelectorAll('.fx-carousel-mobile .fx-carousel-item');

    const dots = document.querySelectorAll('.fx-dot');

    if (this.images.length === 0) return;

    // Update desktop carousel with rotation effect

    if (desktopItems.length > 0) {

      desktopItems.forEach((item, index) => {

        // Remove all position classes

        item.classList.remove('fx-item-current', 'fx-item-prev', 'fx-item-next');

        // Add correct class based on current index

        if (index === this.currentImageIndex) {

          item.classList.add('fx-item-current');

        } else if (index === (this.currentImageIndex + 1) % this.images.length) {

          item.classList.add('fx-item-next');

          // Remove zoom from non-current images

          const img = item.querySelector('img');

          if (img) {

            img.style.cursor = 'pointer';

            img.onclick = null;

          }

        } else if (index === (this.currentImageIndex - 1 + this.images.length) % this.images.length) {

          item.classList.add('fx-item-prev');

          // Remove zoom from non-current images

          const img = item.querySelector('img');

          if (img) {

            img.style.cursor = 'pointer';

            img.onclick = null;

          }

        }

      });

    }

    // Update mobile carousel (simple fade)

    if (mobileItems.length > 0) {

      mobileItems.forEach((item, index) => {

        item.classList.toggle('fx-item-current', index === this.currentImageIndex);

      });

    }

    // Update dots for both carousels

    const desktopDots = document.querySelectorAll('.fx-carousel-desktop .fx-dot');

    const mobileDots = document.querySelectorAll('.fx-carousel-mobile .fx-dot');

    desktopDots.forEach((dot, index) => {

      dot.classList.remove('active');

      if (index === this.currentImageIndex) {

        dot.classList.add('active');

      }

    });

    mobileDots.forEach((dot, index) => {

      dot.classList.remove('active');

      if (index === this.currentImageIndex) {

        dot.classList.add('active');

      }

    });

  }

  getShopifyImageUrl(imageUrl, size) {

    if (!imageUrl) return '';

    // If it's already a placeholder, return as-is

    if (imageUrl.includes('placeholder') || imageUrl.includes('via.placeholder')) {

      return imageUrl;

    }

    // KH-FIX resize server-side ad alta qualita' (dominio custom /cdn/shop/ o cdn.shopify.com)

    if (imageUrl.indexOf('/cdn/shop/') !== -1 || imageUrl.indexOf('cdn.shopify.com') !== -1) {

      var w = parseInt(size, 10) || 1200;

      // togli eventuale suffisso _NxN nel filename e width preesistente, mantieni ?v=

      var u = imageUrl.replace(/_(\d+)x(\d*)\.(jpg|jpeg|png|webp|gif)/i, '.$3').replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');

      var sep = u.indexOf('?') !== -1 ? '&' : '?';

      return u + sep + 'width=' + w;

    }

    // For non-Shopify URLs, return as-is

    return imageUrl;

  }

  // La funzione showConfiguratorBar non è più necessaria - la barra è inline

  setupEventListeners() {

    this.configBtn?.addEventListener('click', () => this.openModal());

    this.configBtnStandalone?.addEventListener('click', () => this.openModal());

    this.configBtnPrimary?.addEventListener('click', () => this.openModal());

    this.close?.addEventListener('click', () => this.closeModal());

    this.modal?.addEventListener('click', (e) => {

      if (e.target === this.modal || e.target.classList.contains('fx-modal-bg')) {

        this.closeModal();

      }

    });

    // Event listeners consolidati per navigazione step

    const nextHandler = () => this.nextStep();

    const prevHandler = () => this.prevStep();

    // Bottoni Avanti (tutti chiamano nextStep)

    ['fxNext2', 'fxNext2Finitura', 'fxNext3Colore', 'fxNext4', 'fxNext5', 'fxNext6'].forEach(id => {

      document.getElementById(id)?.addEventListener('click', nextHandler);

    });

    // Bottoni Indietro (tutti chiamano prevStep)

    ['fxBack2', 'fxBack3', 'fxBack4', 'fxBack5', 'fxBack6', 'fxBack7'].forEach(id => {

      document.getElementById(id)?.addEventListener('click', prevHandler);

    });

    document.getElementById('fxComplete')?.addEventListener('click', () => this.complete());

    // Click sugli step indicator per navigazione diretta

    document.querySelectorAll('.fx-step[data-step]').forEach(stepEl => {

      stepEl.addEventListener('click', () => {

        const targetStep = parseInt(stepEl.dataset.step);

        this.goToStep(targetStep);

      });

    });

    document.addEventListener('keydown', (e) => {

      if (e.key === 'Escape' && this.modal?.classList.contains('active')) {

        this.closeModal();

      }

      // Keyboard carousel controls

      if (e.key === 'ArrowLeft') {

        this.prevImage();

      } else if (e.key === 'ArrowRight') {

        this.nextImage();

      }

    });

    // 🎯 NASCONDI CARD STILE SENZA VARIANTI

    this.hideStyleCardsWithoutVariants();

  }

  hideStyleCardsWithoutVariants() {}

  selectCard(cardElement, type) {

    const step = this.currentStep;

    const value = cardElement.dataset[type] || cardElement.dataset.style;

    // Remove previous selection in current step

    const selector = '.fx-style-card';

    document.querySelectorAll(selector).forEach(card => {

      card.classList.remove('selected');

    });

    // Add selection

    cardElement.classList.add('selected');

    // Save configuration

    const configKeys = ['destination', 'format', 'color', 'finish']; // Aggiornato con 'destination' e 'format'

    this.configuration[configKeys[step - 1]] = value;

    // Gestione primo step (destinazione)

    if (step === 1) {

      this.configuration.destination = value;
      try { console.log('[KH-SHIP] CLICK DESTINAZIONE value=', value); this.updateShipNote(); } catch(e) { console.log('[KH-SHIP] err dest', e); }

      document.getElementById('fxNext2').disabled = false;

    }

    // Enable next button - gestione speciale per step 1 e 2

    let nextBtnId = '';

    if (step === 1) {

      // Step 1: il bottone ha ID fxNext2 (va al passo 2 Formato)

      nextBtnId = 'fxNext2';

    } else if (step === 2) {

      // Step 2: il bottone ha ID fxNext2Finitura (Formato → Finitura)

      nextBtnId = 'fxNext2Finitura';

    } else if (step === 3) {

      // Step 3: il bottone ha ID fxNext3Colore (Finitura → Colore)

      nextBtnId = 'fxNext3Colore';

    } else {

      // Altri step seguono il pattern normale (fxNext4, fxNext5, fxNext6)

      nextBtnId = `fxNext${step}`;

    }

    const nextBtn = document.getElementById(nextBtnId);

    if (nextBtn) {

      nextBtn.disabled = false;

    }

    // Haptic feedback

    if (navigator.vibrate) navigator.vibrate(50);

    // V2: Update sticky summary

    this.updateStickySummary();

  }

  //  METODO PER SELEZIONE COLORI - COLORI HARDCODED

  selectColor(colorCard) {

    const colorId = colorCard.dataset.colorId;

    // Remove previous selection

    document.querySelectorAll('.fx-color-card').forEach(card => {

      card.classList.remove('selected');

    });

    // Add selection

    colorCard.classList.add('selected');

    // Save configuration

    this.configuration.color = colorId;

    // Enable next button - Step 4: Colore → Spessore

    const nextBtn = document.getElementById('fxNext4');

    if (nextBtn) {

      nextBtn.disabled = false;

    }

    // === V2: Anteprima Live Hero ===

    this.updateHeroWithVariantImages();

    this.updateStickySummary();

    // Haptic feedback

    if (navigator.vibrate) navigator.vibrate(50);

  }

  // 🔧 METODO PER SELEZIONE VARIANTI REALI - STEP 4

  selectVariant(variantCard, variant) {

    const variantId = variant.id;

    // Remove previous selection

    document.querySelectorAll('.fx-variant-card').forEach(card => {

      card.classList.remove('selected');

    });

    // Add selection

    variantCard.classList.add('selected');

    // Save configuration

    this.configuration.thickness = this.getThicknessFromVariant(variant);

    this.configuration.selectedVariant = variant;

    // Non aggiorniamo più il titolo con lo spessore

    // Update prices in real-time (solo nel modale)

    this.updatePricesWithVariant(variant);

    // Enable next button - Step 5: Spessore → Quantità

    const nextBtn = document.getElementById('fxNext5');

    if (nextBtn) {

      nextBtn.disabled = false;

    }

    // V2: Update sticky summary with price

    this.updateStickySummary();

    const stickyPrice = document.getElementById('fxStickyPrice');

    if (stickyPrice && variant.price) {

      const priceEur = (variant.price / 100).toFixed(2).replace('.', ',');

      stickyPrice.innerHTML = `€${priceEur}<span class="fx-price-unit">/mq</span>`;

    }

    // Haptic feedback

    if (navigator.vibrate) navigator.vibrate(50);

  }

  updateProductTitleWithFinish(finishType) {}

  // 🟢 Prezzo unitario €/m² (in centesimi) della variante, LIVE da Shopify via this.unitMap.
  // Ritorna {price, compare} in centesimi, oppure null se la variante non ha unit_price (es. battiscopa).
  khUnitCents(variant) {
    const u = (variant && this.unitMap) ? this.unitMap[variant.id] : null;
    if (u && u.p != null) {
      return { price: u.p, compare: (u.c != null && u.c > u.p) ? u.c : null };
    }
    return null;
  }

  khShipContribEuro(formato, thickness) {
    let fmt = String(formato || '').toLowerCase().replace(/×/g, 'x');
    const _dm = fmt.match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/);
    fmt = _dm ? (_dm[1].replace(',', '.') + 'x' + _dm[2].replace(',', '.')) : fmt.replace(/\s/g, '');
    const tnMatch = String(thickness || '').match(/(\d+(?:[.,]\d+)?)/);
    const tn = tnMatch ? tnMatch[1].replace(',', '.') : '';
    const is20 = tn === '20';
    let g;
    if (fmt === '120x120') g = is20 ? 'G8' : 'G4';
    else if (['120x280','120x278','120x240'].includes(fmt)) g = 'G5';
    else if (fmt === '160x320') g = (tn === '12') ? 'G6' : 'G7';
    else if (fmt === '150x300') g = 'G7';
    else if (fmt === '150x150') g = 'G3';
    else if (fmt === '75x150') g = 'G4';
    else if (['80x160','80x180','20x180','26.5x160','26.5x180','90x180'].includes(fmt)) g = 'G3';
    else if (is20) g = 'G2';
    else g = 'G1';
    const SUP = { G1:100, G2:150, G3:150, G4:100, G8:150 };
    const MARK = 1.22;
    if (['G5','G6','G7'].includes(g)) return { euro: Math.round(200*MARK), lastre:true };
    return { euro: Math.round((SUP[g]||100)*MARK), lastre:false };
  }

  updateShipNote(formato, thickness) {
    const note = document.getElementById('fxShipNote');
    console.log('[KH-SHIP] updateShipNote IN formato=', formato, 'thickness=', thickness, 'note?', !!note, 'dest=', this.configuration && this.configuration.destination, 'formatSize=', this.configuration && this.configuration.formatSize);
    if (!note) return;
    formato = formato || (this.configuration && this.configuration.formatSize) || '';
    if (!formato) return;
    thickness = thickness || (this.configuration && this.configuration.thickness) || '';
    if (!thickness && this.configuration && this.configuration.destination === 'ESTERNO') thickness = '20 mm';
    const c = this.khShipContribEuro(formato, thickness);
    console.log('[KH-SHIP] calcolo ->', c);
    const amt = (c.lastre ? 'da ' : '') + c.euro + '&nbsp;&euro;';
    note.innerHTML = 'IVA inclusa <span style="opacity:.45">&middot;</span> Spedizione <span style="color:#2D5A3D;font-weight:700">gratuita</span>';
  }

  updatePricesWithVariant(variant) {

    // Prova a ottenere prezzi fissi personalizzati se disponibili

    let finalPrice = parseFloat(variant.price);

    let finalComparePrice = (variant.compare_at_price && parseFloat(variant.compare_at_price) > finalPrice) ? parseFloat(variant.compare_at_price) : null;

    let formato = null;

    if (variant.option1 && variant.option1.match(/\d+\s*[x×]\s*\d+/i)) {

      formato = variant.option1.match(/(\d+)\s*[x×]\s*(\d+)/i)[0].replace(/\s+/g, '');

    } else if (variant.title && variant.title.match(/\d+\s*[x×]\s*\d+/i)) {

      formato = variant.title.match(/(\d+)\s*[x×]\s*(\d+)/i)[0].replace(/\s+/g, '');

    }

    const colore = variant.option2 || null;

    try { this.updateShipNote(formato, (this.getThicknessFromVariant ? this.getThicknessFromVariant(variant) : (this.configuration && this.configuration.thickness))); } catch(e) {}

    // 🟢 LIVE da Shopify: prezzo €/m² (unit_price) e barrato della variante, via this.unitMap
    const liveU = this.khUnitCents(variant);

    if (liveU) {

      finalPrice = liveU.price; // centesimi (es. 2605 = €26,05/mq)

      finalComparePrice = liveU.compare;

    } else if (formato && typeof window.getPrezzoFissoM2 === 'function') {

      // Fallback (varianti senza unit_price, es. battiscopa)

      const prezziFissi = window.getPrezzoFissoM2(formato, this.product.title, colore);

      if (prezziFissi) {

        finalPrice = prezziFissi.prezzo * 100;

        finalComparePrice = null; /* KH-NOSCONTO: barrato SOLO da compare_at reale Shopify */

      }

    }

    const priceElements = [

      { selector: '#finalPrice', value: this.formatMoney(finalPrice) },

      { selector: '#finalComparePrice', value: this.formatMoney(finalComparePrice) },

      { selector: '#cartPrice', value: this.formatMoney(finalPrice) },

      { selector: '#cartPriceFinal', value: this.formatMoney(finalPrice) }

    ];

    priceElements.forEach(({ selector, value }) => {

      const element = document.querySelector(selector);

      if (element) {

        element.textContent = value;

        // Add highlight animation

        element.style.animation = 'none';

        element.offsetHeight; // Trigger reflow

        element.style.animation = 'fx-price-update 0.5s ease';

      }

    });

    // Update savings amount con prezzi finali

    this.updateSavingsAmountWithPrices(finalPrice, finalComparePrice);

  }

  updateSavingsAmount(variant) {

    const basePrice = parseFloat(variant.price);

    const comparePrice = (variant.compare_at_price && parseFloat(variant.compare_at_price) > basePrice) ? parseFloat(variant.compare_at_price) : null;

    this.updateSavingsAmountWithPrices(basePrice, comparePrice);

  }

  updateSavingsAmountWithPrices(basePrice, comparePrice) {

    const savings = comparePrice - basePrice;

    // Aggiorna solo elementi specifici

    const savingsElements = document.querySelectorAll('#dynamicSavings, #successSavings');

    savingsElements.forEach(element => {

      if (element) {

        element.innerHTML = this.formatMoney(savings) + '<span class="fx-iva-tag">IVA incl.</span>';

      }

    });

  }

  // AGGIORNAMENTO RECAP - FIXATO CON ID CORRETTI (7 STEP CON FINITURA)

  updateSummary() {

    const destinationEl = document.getElementById('fxRecapDestination');

    const styleEl = document.getElementById('fxRecapFormat');

    const finituraEl = document.getElementById('fxRecapFinitura'); // 🆕 Nuovo elemento finitura

    const colorEl = document.getElementById('fxRecapColor');

    const thicknessEl = document.getElementById('fxRecapThickness');

    const titleEl = document.getElementById('fxRecapTitle');

    const priceEl = document.getElementById('fxRecapPrice');

    const comparePriceEl = document.getElementById('fxRecapComparePrice');

    const savingsEl = document.getElementById('fxRecapSavings');

    // Aggiorna titolo - sempre senza spessore

    if (titleEl) {

      titleEl.textContent = this.product.title;

    }

    // Aggiorna destinazione

    if (destinationEl) {

      const destinationNames = {

        'INTERNO': 'Interno',

        'ESTERNO': 'Esterno',

        'RIVESTIMENTO': 'Rivestimento'

      };

      destinationEl.textContent = destinationNames[this.configuration.destination] || this.configuration.destination || '-';

    }

    // Aggiorna formato

    if (styleEl) {

      const formatNames = {};

      styleEl.textContent = formatNames[this.configuration.format] || this.configuration.format || '-';

    }

    // 🆕 Aggiorna finitura

    if (finituraEl) {

      const finituraNames = {

        'naturale': 'Naturale',

        'lucido': 'Lucido',

        'Naturale': 'Naturale',

        'satinato': 'Satinato',

        'strutturato': 'Strutturato',

        'comfort': 'Comfort',

        'bocciardato': 'Bocciardato',

        'liscio': 'Liscio',

        'standard': 'Standard'

      };

      finituraEl.textContent = finituraNames[this.configuration.finitura] || this.configuration.finitura || '-';

    }

    // Aggiorna colore con pallino colorato (solo se non è flusso bianco)

    if (colorEl) {

      {

        const colorLabel = this.getColorLabel(this.configuration.color) || '-';

        const selectedColor = this.colorOptions?.find(c => c.value === this.configuration.color) || null;

        let colorDot = '';

        if (selectedColor && selectedColor.url) {

          // Se ha un'immagine, usa quella come background

          colorDot = `<span style="display: inline-block; width: 24px; height: 24px; border-radius: 50%; background: url('${selectedColor.url}') center/cover no-repeat; border: 2px solid #ddd; vertical-align: middle; margin-right: 10px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"></span>`;

        } else if (selectedColor && selectedColor.hex) {

          // Se ha un colore hex, usa quello

          colorDot = `<span style="display: inline-block; width: 24px; height: 24px; border-radius: 50%; background: ${selectedColor.hex}; border: 2px solid #ddd; vertical-align: middle; margin-right: 10px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"></span>`;

        } else {

          // Default grigio se non trovato

          colorDot = '<span style="display: inline-block; width: 24px; height: 24px; border-radius: 50%; background: #ccc; border: 2px solid #ddd; vertical-align: middle; margin-right: 10px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"></span>';

        }

        colorEl.innerHTML = colorDot + colorLabel;

      }

    }

    // Aggiorna spessore

    if (thicknessEl) {

      // Se abbiamo una variante selezionata, estrai lo spessore da essa

      if (this.configuration.selectedVariant) {

        const extractedThickness = this.getThicknessFromVariant(this.configuration.selectedVariant);

        thicknessEl.textContent = extractedThickness || this.configuration.thickness || '-';

      } else if (this.configuration.thickness) {

        // Altrimenti usa lo spessore configurato

        thicknessEl.textContent = this.configuration.thickness;

      } else {

        thicknessEl.textContent = '-';

      }

    }

    // Aggiorna prezzi se c'è una variante selezionata

    if (this.configuration.selectedVariant) {

      const variant = this.configuration.selectedVariant;

      const basePrice = parseFloat(variant.price);

      const comparePrice = (variant.compare_at_price && parseFloat(variant.compare_at_price) > basePrice) ? parseFloat(variant.compare_at_price) : null;

      const savings = comparePrice ? comparePrice - basePrice : 0;

      if (priceEl) {

        priceEl.innerHTML = this.formatMoney(basePrice) + '<span style="font-size: 1em; color: inherit; font-weight: inherit;">/</span><span class="fx-price-unit">mq</span><span class="fx-iva-tag">IVA incl.</span>';

      }

      if (comparePriceEl) {

        if (comparePrice) {

          comparePriceEl.textContent = this.formatMoney(comparePrice);

          comparePriceEl.style.display = '';

        } else {

          comparePriceEl.textContent = '';

          comparePriceEl.style.display = 'none';

        }

      }

      if (savingsEl) {

        if (savings > 0) {

          savingsEl.innerHTML = `<strong>${this.formatMoney(savings)}</strong>`;

          savingsEl.style.display = '';

        } else {

          savingsEl.innerHTML = '';

          savingsEl.style.display = 'none';

        }

      }

      // Aggiorna l'immagine del recap se la variante ha un'immagine

      const recapImg = document.getElementById('fxRecapImg');

      if (recapImg && variant.featured_image) {

        recapImg.src = variant.featured_image.src;

        recapImg.alt = variant.title;

      }

    }

  }

  // 🔧 POPOLA STEP 4 CON GLI SPESSORI REALI DALLE VARIANTI SHOPIFY

  populateVariantsStep(format) {

    const container = document.getElementById('fxVariantsContainer');

    if (!container) {

      return;

    }

    container.innerHTML = '';

    // Usa il nuovo metodo per ottenere gli spessori

    const spessoriDisponibili = this.populateThicknessForSelection(

      this.configuration.formatSize, 

      this.configuration.color

    );

    // Se usiamo i dati già organizzati

    let variantsToShow = [];

    if (this.configuration.formatSize && this.variants.byFormat[this.configuration.formatSize]) {

      variantsToShow = this.variants.byFormat[this.configuration.formatSize];

      // Filtra ulteriormente per colore se selezionato

      if (this.configuration.color) {

        variantsToShow = variantsToShow.filter(variant => 

          variant.option2 === this.configuration.color || 

          (variant.title && variant.title.includes(this.configuration.color))

        );

      }

    }

    // Estrai gli spessori unici dalle varianti filtrate

    const spessoriSet = new Set();

    const spessoriVariants = new Map();

    variantsToShow.forEach(variant => {

      // Cerca lo spessore nelle opzioni della variante

      let spessore = null;

      // Controlla option1, option2, option3 per trovare lo spessore

      // Pattern migliorato per catturare formati come "9.5 mm r10" o "10mm" o "3 mm"

      [variant.option1, variant.option2, variant.option3].forEach(option => {

        if (option) {

          // Pattern che cattura: numero (con decimali) + mm + eventuale codice (es: r10, r11)

          const spessorePattern = /\d+(?:[.,]\d+)?\s*mm(?:\s+r\d+)?/i;

          const match = option.match(spessorePattern);

          if (match) {

            spessore = option.trim(); // Prende l'intera opzione che contiene lo spessore

          }

        }

      });

      // Se non trovato nelle opzioni, cerca nel titolo

      if (!spessore) {

        const spessorePattern = /(\d+(?:[.,]\d+)?\s*mm(?:\s+r\d+)?)/i;

        const spessoreMatch = variant.title.match(spessorePattern);

        if (spessoreMatch) {

          spessore = spessoreMatch[1];

        }

      }

      // Se trovato uno spessore, aggiungilo alla lista

      if (spessore) {

        // Normalizza spessore: rimuovi R9/R10/R11 per raggruppare varianti con stessa resistenza

        const spessoreNormalized = spessore.replace(/\s*R\d+/gi, '').trim();



        spessoriSet.add(spessoreNormalized);

        if (!spessoriVariants.has(spessoreNormalized)) {

          spessoriVariants.set(spessoreNormalized, []);

        }

        spessoriVariants.get(spessoreNormalized).push(variant);

      }

    });

    // Se non ci sono spessori disponibili

    if (spessoriSet.size === 0) {

      container.innerHTML = `

        <div style="text-align: center; color: var(--fx-text-muted); grid-column: 1/-1; padding: 2rem;">

          <p>❌ Nessuno spessore disponibile per questa selezione.</p>

          <p style="font-size: 0.875rem; margin-top: 1rem;">Formato selezionato: <strong>${this.configuration.formatSize || 'Non selezionato'}</strong></p>

          <p style="font-size: 0.875rem;">Colore selezionato: <strong>${this.configuration.color || 'Non selezionato'}</strong></p>

        </div>

      `;

      return;

    }

    // Ordina gli spessori numericamente (gestendo anche decimali)

    const spessoriOrdinati = Array.from(spessoriSet).sort((a, b) => {

      // Estrai il numero (con decimali) dallo spessore

      const numA = parseFloat(a.match(/\d+(?:[.,]\d+)?/)?.[0]?.replace(',', '.') || 0);

      const numB = parseFloat(b.match(/\d+(?:[.,]\d+)?/)?.[0]?.replace(',', '.') || 0);

      return numA - numB;

    });

    // Mostra ogni spessore come opzione

    spessoriOrdinati.forEach(spessore => {

      const variants = spessoriVariants.get(spessore);

      const variant = variants[0]; // Usa la prima variante con questo spessore

      const variantCard = document.createElement('div');

      variantCard.className = 'fx-variant-card';

      variantCard.dataset.variantId = variant.id;

      // Estrai info dalla variante + supporto lucida/Naturale

      const variantInfo = this.extractVariantInfo(variant);

      // Rileva se è lucida o Naturale dal nome

      const finishType = this.detectFinishType(variant);

      // Usa il colore selezionato nello step 2, o fallback al colore generato

      let sampleColor = variantInfo.color;

      // Se abbiamo un colore selezionato nello step 2, usiamolo

      if (this.configuration.color) {

        if (selectedColor && selectedColor.url) {

          // Usa l'immagine del colore come background

          sampleColor = `url('${selectedColor.url}')`;

        }

      }

      // Crea lo stile inline completo per il background

      let backgroundStyle = '';

      if (sampleColor.startsWith('url(')) {

        // Se è un'immagine, usa cover per riempire sempre completamente

        backgroundStyle = `background: #D9D2C5 ${sampleColor} center/cover no-repeat;`;

      } else {

        // Se è un colore o gradiente, usa solo background

        backgroundStyle = `background: ${sampleColor};`;

      }

      // Usa lo spessore normalizzato come nome da visualizzare

      const variantDisplayName = spessore.toUpperCase();

      variantCard.innerHTML = `

        <div class="fx-variant-preview">

          <div class="fx-variant-sample ${finishType.effect}" style="${backgroundStyle}"></div>

        </div>

        <div class="fx-variant-info">

          <h4>${variantDisplayName}</h4>

          <div class="fx-variant-price">${this.formatMoney(variant.price)}</div>

        </div>

        <div class="fx-variant-select">

          <div class="fx-variant-select-ring"></div>

          <div class="fx-variant-select-dot"></div>

        </div>

      `;

      // Add click handler

      variantCard.addEventListener('click', () => this.selectVariant(variantCard, variant));

      variantCard.addEventListener('dblclick', () => {

        this.selectVariant(variantCard, variant);

        setTimeout(() => this.nextStep(), 100);

      });

      container.appendChild(variantCard);

    });

  }

  // 🌟 RILEVA TIPO SPESSORE (LUCIDO/Naturale) DAL NOME DELLA VARIANTE

  detectFinishType(variant) {

    const variantText = `${variant.title} ${variant.option1 || ''} ${variant.option2 || ''} ${variant.option3 || ''}`.toLowerCase();

    // Parole chiave per spessore lucido

    const glossyKeywords = ['lucida', 'lucido', 'glossy', 'gloss', 'brillante', 'shiny', 'polished', 'mirror', 'lustro'];

    // Parole chiave per spessore Naturale

    const NaturaleKeywords = ['Naturale', 'Naturale', 'Naturale', 'matt', 'satinata', 'satinato', 'satin', 'soft', 'rough'];

    const isGlossy = glossyKeywords.some(keyword => variantText.includes(keyword));

    const isNaturale = NaturaleKeywords.some(keyword => variantText.includes(keyword));

    if (isGlossy) {

      return {

        type: 'fx-glossy',

        effect: 'fx-glossy',

        badge: 'LUCIDA'

      };

    } else if (isNaturale) {

      return {

        type: 'fx-Naturale', 

        effect: '',

        badge: 'Naturale'

      };

    } else {

      // Prova a rilevare da altre indicazioni nel nome

      if (variantText.includes('bianco') && !variantText.includes('opac')) {

        // Bianco di default è spesso lucida

        return {

          type: 'fx-glossy',

          effect: 'fx-glossy',

          badge: 'LUCIDA'

        };

      }

      // Default: nessun badge, spessore standard

      return {

        type: '',

        effect: '',

        badge: null

      };

    }

  }

  // 🔍 ESTRAI INFO DA VARIANTE

  extractVariantInfo(variant) {

    const title = variant.title;

    const option1 = variant.option1 || '';

    const option2 = variant.option2 || '';

    const option3 = variant.option3 || '';

    // Try to find variant image

    let variantImage = null;

    if (variant.featured_image) {

      variantImage = variant.featured_image.src;

    } else if (variant.image) {

      variantImage = variant.image.src;

    }

    // Extract variant name PREFERENDO SEMPRE LE OPTIONS (che sono i nomi delle varianti specifiche)

    let displayName = '';

    // Priorità 1: Cerca nelle opzioni (escludendo 'default' e nomi di modello)

    const options = [option1, option2, option3].filter(opt => 

      opt && 

      !opt.toLowerCase().includes('default') && 

      !opt.toLowerCase().includes(this.product.title.toLowerCase().split(' ')[0]) // Esclude prima parola del titolo prodotto

    );

    if (options.length > 0) {

      // Usa la prima opzione valida trovata

      displayName = options[0];

    } else {

      // Priorità 2: Estrai dalla fine del title (spesso contiene la variante specifica)

      const titleParts = title.split(/[-\/|]/).map(part => part.trim());

      if (titleParts.length > 1) {

        // Prende l'ultima parte che solitamente è la variante

        displayName = titleParts[titleParts.length - 1];

      } else {

        // Priorità 3: Cerca parole chiave nel title per estrarre la variante

        const variantKeywords = ['bianco', 'Naturale', 'lucido', 'Naturale', 'glossy', 'total color', 'color system', 'decor dress'];

        const foundKeyword = variantKeywords.find(keyword => 

          title.toLowerCase().includes(keyword)

        );

        if (foundKeyword) {

          displayName = foundKeyword.charAt(0).toUpperCase() + foundKeyword.slice(1);

        } else {

          // Fallback: usa il title ma accorciato

          displayName = title.length > 20 ? title.substring(0, 20) + '...' : title;

        }

      }

    }

    // Pulisci il nome finale

    displayName = displayName.trim();

    // Generate fallback color

    const fallbackColor = this.generateColorFromName(displayName);

    return {

      displayName: displayName,

      image: variantImage,

      color: fallbackColor

    };

  }

  //  GENERA COLORE DA NOME

  generateColorFromName(name) {

    const hash = name.split('').reduce((a, b) => {

      a = ((a << 5) - a) + b.charCodeAt(0);

      return a & a;

    }, 0);

    const hue = Math.abs(hash) % 360;

    const saturation = 40 + (Math.abs(hash) % 40);

    const lightness = 60 + (Math.abs(hash) % 25);

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;

  }

  getColorLabel(colorId) {

    if (!colorId) return null;

    return colorId;

  }

  

  // 🔄 NAVIGAZIONE AGGIORNATA V2 - CON TRANSIZIONI ANIMATE

  nextStep() {

    if (this.currentStep < this.maxSteps) {

      const prevStepNum = this.currentStep;

      const currentSection = document.getElementById(`fxStep${this.currentStep}`);

      // Marca step corrente come completato

      const currentStepEl = document.querySelector(`.fx-step[data-step="${this.currentStep}"]`);

      currentStepEl?.classList.add('completed');

      currentStepEl?.classList.remove('active');

      // Animazione uscita verso sinistra

      if (currentSection) {

        currentSection.classList.remove('active');

        currentSection.classList.add('fx-exit-left');

        setTimeout(() => {

          currentSection.classList.remove('fx-exit-left');

        }, 300);

      }

      this.currentStep++;

      // Dopo il delay, mostra il nuovo step

      setTimeout(() => {

        const newSection = document.getElementById(`fxStep${this.currentStep}`);

        if (newSection) {

          newSection.classList.remove('fx-enter-reverse');

          newSection.classList.add('active');

        }

        document.querySelector(`.fx-step[data-step="${this.currentStep}"]`)?.classList.add('active');

        // Aggiorna progress bar

        this.updateProgressBar();

        // Aggiorna sticky summary

        this.updateStickySummary();

        // Scroll al top del modal

        const modalContainer = document.querySelector('.fx-modal-container');

        if (modalContainer) modalContainer.scrollTop = 0;

      }, 300);

      // Step 2 → 3: Dopo selezione formato, popola finiture

      if (this.currentStep === 3) {

        if (window.ConfiguratoreDataUniversal?.populateFiniture) {

          window.ConfiguratoreDataUniversal.populateFiniture();

        }

      }

      // Step 3 → 4: Dopo selezione finitura, popola colori

      if (this.currentStep === 4) {

        if (window.ConfiguratoreDataUniversal?.populateColors) {

          window.ConfiguratoreDataUniversal.populateColors();

        }

      }

      // Step 4 → 5: Dopo selezione colore, popola spessori
      if (this.currentStep === 5) {
        if (window.ConfiguratoreDataUniversal?.filterThicknessByDestinationAndColor) {
          window.ConfiguratoreDataUniversal.filterThicknessByDestinationAndColor();
        } else if (window.ConfiguratoreDataUniversal?.populateThickness) {
          window.ConfiguratoreDataUniversal.populateThickness();
        }
      }

      // Update summary when reaching final step (step 7)

      if (this.currentStep === this.maxSteps) {

        setTimeout(() => {

          this.findAndSelectMatchingVariant();

          // this.updateSummary(); // ← COMMENTATO: ora usa populateRecap() del configuratore universale

        }, 350);

      }

    }

  }

  prevStep() {

    if (this.currentStep > 1) {

      const currentSection = document.getElementById(`fxStep${this.currentStep}`);

      // Rimuovi active dallo step corrente

      document.querySelector(`.fx-step[data-step="${this.currentStep}"]`)?.classList.remove('active');

      // Animazione uscita verso destra

      if (currentSection) {

        currentSection.classList.remove('active');

        currentSection.classList.add('fx-exit-right');

        setTimeout(() => {

          currentSection.classList.remove('fx-exit-right');

        }, 300);

      }

      this.currentStep--;

      // Dopo il delay, mostra lo step precedente con entrata da sinistra

      setTimeout(() => {

        const prevSection = document.getElementById(`fxStep${this.currentStep}`);

        if (prevSection) {

          prevSection.classList.add('fx-enter-reverse');

          prevSection.classList.add('active');

        }

        const stepEl = document.querySelector(`.fx-step[data-step="${this.currentStep}"]`);

        stepEl?.classList.remove('completed');

        stepEl?.classList.add('active');

        // Aggiorna progress bar

        this.updateProgressBar();

        // Aggiorna sticky summary

        this.updateStickySummary();

        // Scroll al top del modal

        const modalContainer = document.querySelector('.fx-modal-container');

        if (modalContainer) modalContainer.scrollTop = 0;

      }, 300);

    }

  }

  // === NAVIGAZIONE DIRETTA TRAMITE STEP INDICATOR ===

  goToStep(targetStep) {

    if (targetStep === this.currentStep) return;

    if (targetStep < 1 || targetStep > this.maxSteps) return;

    // Permetti navigazione solo verso step gia' visitati (completed o active)

    const targetEl = document.querySelector(`.fx-step[data-step="${targetStep}"]`);

    if (!targetEl || (!targetEl.classList.contains('completed') && !targetEl.classList.contains('active'))) return;

    const goingForward = targetStep > this.currentStep;

    const currentSection = document.getElementById(`fxStep${this.currentStep}`);

    const currentStepEl = document.querySelector(`.fx-step[data-step="${this.currentStep}"]`);

    currentStepEl?.classList.remove('active');

    if (goingForward) {

      currentStepEl?.classList.add('completed');

    }

    if (currentSection) {

      currentSection.classList.remove('active');

      currentSection.classList.add(goingForward ? 'fx-exit-left' : 'fx-exit-right');

      setTimeout(() => {

        currentSection.classList.remove(goingForward ? 'fx-exit-left' : 'fx-exit-right');

      }, 300);

    }

    this.currentStep = targetStep;

    setTimeout(() => {

      const newSection = document.getElementById(`fxStep${this.currentStep}`);

      if (newSection) {

        if (!goingForward) newSection.classList.add('fx-enter-reverse');

        newSection.classList.add('active');

      }

      const newStepEl = document.querySelector(`.fx-step[data-step="${this.currentStep}"]`);

      newStepEl?.classList.remove('completed');

      newStepEl?.classList.add('active');

      this.updateProgressBar();

      this.updateStickySummary();

      const modalContainer = document.querySelector('.fx-modal-container');

      if (modalContainer) modalContainer.scrollTop = 0;

    }, 300);

    if (this.currentStep === 3 && window.ConfiguratoreDataUniversal?.populateFiniture) {

      window.ConfiguratoreDataUniversal.populateFiniture();

    }

    if (this.currentStep === 4 && window.ConfiguratoreDataUniversal?.populateColors) {

      window.ConfiguratoreDataUniversal.populateColors();

    }

    if (this.currentStep === 5) {
      if (window.ConfiguratoreDataUniversal?.filterThicknessByDestinationAndColor) {
        window.ConfiguratoreDataUniversal.filterThicknessByDestinationAndColor();
      } else if (window.ConfiguratoreDataUniversal?.populateThickness) {
        window.ConfiguratoreDataUniversal.populateThickness();
      }
    }

  }

  // === PROGRESS BAR (rimossa dall'UI) ===

  updateProgressBar() {

    const container = document.querySelector('.fx-progress-bar-container');

    if (container) container.style.display = 'none';

  }

  // === STICKY SUMMARY ===

  updateStickySummary() {

    const sticky = document.getElementById('fxStickySummary');

    if (!sticky) return;

    // Mostra solo dal step 2 in poi e quando il modal è aperto

    if (this.currentStep >= 2 && this.modal?.classList.contains('active')) {

      sticky.classList.add('visible');

    } else {

      sticky.classList.remove('visible');

    }

    // Aggiorna chip

    const dest = document.getElementById('fxStickyDest');

    const fmt = document.getElementById('fxStickyFormat');

    const fin = document.getElementById('fxStickyFinish');

    const col = document.getElementById('fxStickyColor');

    // Destinazione: mostra etichetta leggibile

    if (this.configuration.destination && dest) {

      const destLabels = {

        'PAVIMENTO': 'Pavimento',

        'RIVESTIMENTO': 'Rivestimento',

        'BATTISCOPA': 'Battiscopa',

        'OUTDOOR': 'Outdoor',

        'VASCA': 'Vasca',

        'LAVABO': 'Lavabo'

      };

      dest.querySelector('span').textContent = destLabels[this.configuration.destination] || this.configuration.destination;

      dest.classList.add('active');

    }

    // Formato: usa formatSize se disponibile, altrimenti format o formatoDimensionale

    const formatValue = this.configuration.formatSize || this.configuration.format || this.configuration.formatoDimensionale;

    if (formatValue && fmt) {

      // Estrai solo le dimensioni (es. "60x60" da "60x60 Naturale Rettificato")

      const dimensionMatch = formatValue.match(/(\d+\s?[x×]\s?\d+)/i);

      const displayFormat = dimensionMatch ? dimensionMatch[1].replace(/\s/g, '') : formatValue.split(' ')[0];

      fmt.querySelector('span').textContent = displayFormat;

      fmt.classList.add('active');

    }

    // Finitura

    if ((this.configuration.finituraLabel || this.configuration.finitura) && fin) {

      fin.querySelector('span').textContent = this.configuration.finituraLabel || this.configuration.finitura;

      fin.classList.add('active');

    }

    // Colore

    if (this.configuration.color && col) {

      col.querySelector('span').textContent = this.configuration.color;

      col.classList.add('active');

    }

  }

  // === 1. ANTEPRIMA LIVE HERO ===

  updateHeroWithVariantImages() {

    if (!this.configuration.color) return;

    // Trova varianti che corrispondono al colore selezionato

    const matchingVariants = this.product.variants.filter(v => {

      return v.option2 && v.option2.toLowerCase() === this.configuration.color.toLowerCase();

    });

    if (matchingVariants.length > 0 && matchingVariants[0].featured_image) {

      const newImageUrl = matchingVariants[0].featured_image.src;

      if (newImageUrl) {

        // Aggiorna l'immagine corrente nel carousel con crossfade

        const currentItem = document.querySelector('.fx-carousel-desktop .fx-item-current');

        if (currentItem) {

          const img = currentItem.querySelector('img');

          if (img) {

            currentItem.classList.add('fx-crossfade');

            setTimeout(() => {

              img.src = this.getShopifyImageUrl(newImageUrl, '1200x1200');

              currentItem.classList.remove('fx-crossfade');

            }, 400);

          }

        }

        // Mostra badge "Anteprima Live"

        const badge = document.getElementById('fxHeroLiveBadge');

        if (badge) badge.classList.add('visible');

        // Aggiorna thumbnail sticky

        const stickyImg = document.getElementById('fxStickyThumbImg');

        if (stickyImg) stickyImg.src = this.getShopifyImageUrl(newImageUrl, '100x100');

        // Aggiorna room preview se attivo

        this.updateRoomPreview(newImageUrl);

      }

    }

  }

  // === 2. ROOM PREVIEW ===

  initRoomPreview() {

    const tabs = document.querySelectorAll('.fx-view-tab');

    const carousel = document.getElementById('fxProductCarousel');

    const roomPreview = document.getElementById('fxRoomPreview');

    const roomBtns = document.querySelectorAll('.fx-room-btn');

    tabs.forEach(tab => {

      tab.addEventListener('click', () => {

        tabs.forEach(t => t.classList.remove('active'));

        tab.classList.add('active');

        if (tab.dataset.view === 'room') {

          if (carousel) carousel.style.display = 'none';

          if (roomPreview) roomPreview.classList.add('active');

        } else {

          if (carousel) carousel.style.display = '';

          if (roomPreview) roomPreview.classList.remove('active');

        }

      });

    });

    roomBtns.forEach(btn => {

      btn.addEventListener('click', () => {

        roomBtns.forEach(b => b.classList.remove('active'));

        btn.classList.add('active');

        this.setRoomScene(btn.dataset.room);

      });

    });

  }

  setRoomScene(room) {

    const scene = document.getElementById('fxRoomScene');

    if (!scene) return;

    const rooms = {

      bagno: { bg: 'linear-gradient(180deg, #e8e4e0 0%, #d4cfc9 45%, #c8c2bb 100%)', wallColor: 'rgba(232,228,224,0.8)' },

      soggiorno: { bg: 'linear-gradient(180deg, #f5f0eb 0%, #ebe5de 45%, #ddd7cf 100%)', wallColor: 'rgba(245,240,235,0.8)' },

      cucina: { bg: 'linear-gradient(180deg, #f0ede8 0%, #e5e0d8 45%, #d8d2c8 100%)', wallColor: 'rgba(240,237,232,0.8)' },

      esterno: { bg: 'linear-gradient(180deg, #87CEEB 0%, #98D4EE 35%, #d4cfc9 50%, #c0b8ae 100%)', wallColor: 'rgba(135,206,235,0.5)' }

    };

    const config = rooms[room] || rooms.bagno;

    scene.style.background = config.bg;

  }

  updateRoomPreview(imageUrl) {

    const floor = document.getElementById('fxRoomFloor');

    const wall = document.getElementById('fxRoomWall');

    const noSelection = document.getElementById('fxRoomNoSelection');

    if (imageUrl && floor) {

      const tileUrl = this.getShopifyImageUrl(imageUrl, '300x300');

      floor.style.backgroundImage = `url(${tileUrl})`;

      floor.style.display = 'block';

      if (wall) {

        wall.style.backgroundImage = `url(${tileUrl})`;

        wall.style.display = 'block';

      }

      if (noSelection) noSelection.style.display = 'none';

    }

  }

  // === 9. PALLET PROGRESS ===

  updatePalletProgress(currentQty, palletQty) {

    const container = document.getElementById('fxPalletProgress');

    if (!container || !palletQty) return;

    container.style.display = 'block';

    const fill = document.getElementById('fxPalletBarFill');

    const count = document.getElementById('fxPalletCount');

    const message = document.getElementById('fxPalletMessage');

    const percentage = Math.min((currentQty / palletQty) * 100, 100);

    if (fill) {

      fill.style.width = `${percentage}%`;

      if (percentage >= 100) fill.classList.add('complete');

      else fill.classList.remove('complete');

    }

    if (count) count.textContent = `${currentQty}/${palletQty} scatole`;

    if (message) {

      if (currentQty >= palletQty) {

        message.classList.add('discount-active');

        message.innerHTML = '<span class="fx-pallet-badge"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> BANCALE COMPLETO</span>';

      } else {

        message.classList.remove('discount-active');

        const remaining = palletQty - currentQty;

        message.textContent = `Aggiungi ${remaining} scatol${remaining === 1 ? 'a' : 'e'} per completare il bancale`;

      }

    }

  }

  openModal() {

    this.modal?.classList.add('active');

    // Blocca completamente lo scroll della pagina

    document.body.style.overflow = 'hidden';

    document.body.style.position = 'fixed';

    document.body.style.width = '100%';

    document.body.style.top = `-${window.scrollY}px`;

    document.body.dataset.scrollPosition = window.scrollY;

    // Previeni scroll su iOS

    document.documentElement.style.overflow = 'hidden';

    // Mostra sticky summary se step > 1

    this.updateStickySummary();

    this.updateProgressBar();

  }

  closeModal() {

    this.modal?.classList.remove('active');

    // Ripristina lo scroll della pagina

    const scrollY = document.body.dataset.scrollPosition || 0;

    document.body.style.overflow = '';

    document.body.style.position = '';

    document.body.style.width = '';

    document.body.style.top = '';

    document.documentElement.style.overflow = '';

    window.scrollTo(0, parseInt(scrollY));

    delete document.body.dataset.scrollPosition;

    // Nascondi sticky summary

    const sticky = document.getElementById('fxStickySummary');

    if (sticky) sticky.classList.remove('visible');

    // Clear auto-rotate when modal is closed

    if (this.autoRotateInterval) {

      clearInterval(this.autoRotateInterval);

      this.autoRotateInterval = null;

    }

  }

  // IMAGE ZOOM METHODS

  openImageZoom(imageSrc) {

    // ZOOM SOLO SU MOBILE

    const isMobile = window.innerWidth <= 768;

    if (!isMobile) {

      return; // Esce dalla funzione su desktop

    }

    const modal = document.getElementById('fxImageZoomModal');

    const zoomContent = document.getElementById('fxZoomContent');

    const zoomedImage = document.getElementById('fxZoomedImage');

    if (modal && zoomContent) {

      // Check if mobile

      const isMobile = window.innerWidth <= 768;

      if (isMobile) {

        // Su mobile, crea tutte le immagini per swipe

        zoomContent.innerHTML = '';

        // Crea le immagini

        this.images.forEach((img, index) => {

          const imgElement = document.createElement('img');

          imgElement.className = 'fx-zoomed-image';

          imgElement.src = img;

          imgElement.alt = this.product.title + ' — immagine ' + (index + 1);

          imgElement.dataset.index = index;

          imgElement.loading = 'eager'; // Carica immediatamente

          imgElement.style.visibility = 'visible'; // Forza visibilità

          zoomContent.appendChild(imgElement);

        });

        // Crea i dots

        const dotsContainer = document.createElement('div');

        dotsContainer.className = 'fx-zoom-dots';

        this.images.forEach((_, index) => {

          const dot = document.createElement('div');

          dot.className = 'fx-zoom-dot';

          dot.dataset.index = index;

          dot.onclick = () => this.goToZoomImage(index);

          dotsContainer.appendChild(dot);

        });

        zoomContent.appendChild(dotsContainer);

        // Trova l'indice corrente

        this.currentZoomIndex = this.images.findIndex(img => img === imageSrc);

        if (this.currentZoomIndex === -1) {

          this.currentZoomIndex = 0; // Default alla prima immagine se non trovata

        }

        // Imposta l'immagine attiva iniziale

        // Applica immediatamente la classe active all'immagine corrente

        const allImages = zoomContent.querySelectorAll('.fx-zoomed-image');

        const allDots = dotsContainer.querySelectorAll('.fx-zoom-dot');

        // Reset tutte le immagini

        allImages.forEach((img) => {

          img.classList.remove('active', 'prev', 'next');

          img.style.opacity = '0';

        });

        // Imposta l'immagine corrente come attiva

        if (allImages[this.currentZoomIndex]) {

          allImages[this.currentZoomIndex].classList.add('active');

          allImages[this.currentZoomIndex].style.opacity = '1';

          allImages[this.currentZoomIndex].style.visibility = 'visible';

        }

        // Imposta il dot attivo

        allDots.forEach((dot, index) => {

          dot.classList.toggle('active', index === this.currentZoomIndex);

        });

        // Doppio check dopo il rendering

        setTimeout(() => {

          this.updateMobileZoomView();

          // Forza visibilità se ancora nascosta

          const activeImg = zoomContent.querySelector('.fx-zoomed-image.active');

          if (activeImg) {

            activeImg.style.opacity = '1';

            activeImg.style.visibility = 'visible';

          }

        }, 100);

        // Setup swipe gestures

        this.setupSwipeGestures(zoomContent);

      } else {

        // Su desktop, mantieni il comportamento originale con frecce

        if (zoomedImage) {

          zoomedImage.src = imageSrc;

        } else {

          // Crea l'immagine se non esiste

          zoomContent.innerHTML = `

            <img class="fx-zoomed-image" id="fxZoomedImage" src="${imageSrc}" alt="${this.product.title} — zoom" width="1200" height="1200">

            <div class="fx-zoom-controls">

              <button class="fx-zoom-prev" onclick="window.ceramicaEuroConfig.prevZoomImage()"></button>

              <button class="fx-zoom-next" onclick="window.ceramicaEuroConfig.nextZoomImage()"></button>

            </div>

          `;

        }

        this.currentZoomIndex = this.images.findIndex(img => img === imageSrc);

      }

      modal.classList.add('active');

      document.body.style.overflow = 'hidden';

    }

  }

  // Nuovo metodo per gestire swipe

  setupSwipeGestures(element) {

    let startX = 0;

    let startY = 0;

    let distX = 0;

    let distY = 0;

    const threshold = 50; // Minima distanza per considerare uno swipe

    const restraint = 100; // Massima distanza verticale permessa

    element.addEventListener('touchstart', (e) => {

      const touch = e.changedTouches[0];

      startX = touch.pageX;

      startY = touch.pageY;

    }, { passive: true });

    element.addEventListener('touchend', (e) => {

      const touch = e.changedTouches[0];

      distX = touch.pageX - startX;

      distY = touch.pageY - startY;

      if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {

        if (distX > 0) {

          // Swipe right - immagine precedente

          this.prevZoomImage();

        } else {

          // Swipe left - immagine successiva

          this.nextZoomImage();

        }

      }

    }, { passive: true });

  }

  // Aggiorna la vista mobile

  updateMobileZoomView() {

    const images = document.querySelectorAll('.fx-zoomed-image');

    const dots = document.querySelectorAll('.fx-zoom-dot');

    const totalImages = this.images.length;

    images.forEach((img, index) => {

      img.classList.remove('active', 'prev', 'next');

      // Reset opacity e z-index per tutte le immagini

      img.style.opacity = '0';

      img.style.zIndex = '0';

      if (index === this.currentZoomIndex) {

        img.classList.add('active');

        img.style.opacity = '1';

        img.style.zIndex = '100';

      } else if (index === this.currentZoomIndex - 1 ||

                (this.currentZoomIndex === 0 && index === totalImages - 1)) {

        img.classList.add('prev');

        img.style.zIndex = '1';

      } else if (index === this.currentZoomIndex + 1 ||

                (this.currentZoomIndex === totalImages - 1 && index === 0)) {

        img.classList.add('next');

        img.style.zIndex = '1';

      }

    });

    dots.forEach((dot, index) => {

      dot.classList.toggle('active', index === this.currentZoomIndex);

    });

  }

  // Vai a immagine specifica

  goToZoomImage(index) {

    if (index >= 0 && index < this.images.length) {

      this.currentZoomIndex = index;

      const isMobile = window.innerWidth <= 768;

      if (isMobile) {

        this.updateMobileZoomView();

      } else {

        const zoomedImage = document.getElementById('fxZoomedImage');

        if (zoomedImage) {

          zoomedImage.src = this.images[index];

        }

      }

    }

  }

  closeImageZoom() {

    const modal = document.getElementById('fxImageZoomModal');

    if (modal) {

      modal.classList.remove('active');

      document.body.style.overflow = '';

    }

  }

  // Add keyboard support for image zoom

  setupImageZoomKeyboard() {

    document.addEventListener('keydown', (e) => {

      const modal = document.getElementById('fxImageZoomModal');

      if (modal && modal.classList.contains('active')) {

        if (e.key === 'Escape') {

          this.closeImageZoom();

        } else if (e.key === 'ArrowLeft') {

          this.prevZoomImage();

        } else if (e.key === 'ArrowRight') {

          this.nextZoomImage();

        }

      }

    });

  }

  prevZoomImage() {

    if (this.currentZoomIndex > 0) {

      this.currentZoomIndex--;

    } else {

      this.currentZoomIndex = this.images.length - 1;

    }

    this.updateZoomImage();

  }

  nextZoomImage() {

    if (this.currentZoomIndex < this.images.length - 1) {

      this.currentZoomIndex++;

    } else {

      this.currentZoomIndex = 0;

    }

    this.updateZoomImage();

  }

  updateZoomImage() {

    const isMobile = window.innerWidth <= 768;

    if (isMobile) {

      this.updateMobileZoomView();

    } else {

      const zoomedImage = document.getElementById('fxZoomedImage');

      if (zoomedImage && this.images[this.currentZoomIndex]) {

        zoomedImage.src = this.images[this.currentZoomIndex];

      }

    }

  }

  async complete() {

    try {

      // Usa il configuratore appropriato se disponibile

      const configuratore = window.isSupergresProduct

        ? window.ConfiguratoreDataSupergres

        : window.ConfiguratoreDataLight;

      if (configuratore && typeof configuratore.complete === 'function') {

        return await configuratore.complete();

      }

      // Fallback: logica originale

      // Validation: assicurati che ci sia una variante selezionata

      if (!this.configuration.selectedVariant) {

        alert('Per favore seleziona una variante prima di procedere.');

        return;

      }

      // Applica la configurazione al form e aggiungi al carrello

      const addedToCart = await this.applyToShopifyProduct();

      if (addedToCart) {

        // Chiudi il configuratore e apri il cart drawer
        this.closeModal();

        // Apri il cart drawer dopo un breve delay
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            // Fallback: trigger click sul cart icon
            const cartIcon = document.querySelector('.Header__Action--cart a, .cart-icon-bubble, [data-cart-toggle]');
            if (cartIcon) cartIcon.click();
          }
        }, 300);

      }

    } catch (error) {


    }

  }

  async applyToShopifyProduct() {

    try {

      // Update success details first

      this.updateSuccessDetails();

      // Prepare cart data

      const cartData = {

        items: [{

          id: this.configuration.selectedVariant.id,

          quantity: 1,

          properties: {

            'Formato': this.getFormatLabel(this.configuration.format),

            'Colore': this.getColorValue(),

            'Spessore': this.configuration.thickness || 'Non selezionato',

            '_Variante ID': this.configuration.selectedVariant?.id || '',

            '_Prezzo Configurato': this.configuration.selectedVariant ? this.formatMoney(this.configuration.selectedVariant.price) : '',

            '_Configurazione ID': this.generateConfigId(),

            '_Configurazione Data': new Date().toISOString(),

            '_Configuratore': 'FORMAQUAE AI v2.0',

            '_Flusso': 'STANDARD'

          }

        }]

      };

      // Add to cart via Shopify Cart API

      const response = await fetch('/cart/add.js', {

        method: 'POST',

        headers: {

          'Content-Type': 'application/json',

        },

        body: JSON.stringify(cartData)

      });

      if (response.ok) {

        const result = await response.json();

        // Wait a moment for cart to be fully updated

        await new Promise(resolve => setTimeout(resolve, 500));

        // Verify the item was actually added

        const verifyResponse = await fetch('/cart.js');

        const currentCart = await verifyResponse.json();

        const addedItem = currentCart.items.find(item => 

          item.variant_id === this.configuration.selectedVariant.id

        );

        if (addedItem) {

          // Trigger custom event for other integrations

          window.dispatchEvent(new CustomEvent('fxConfigurationApplied', {

            detail: {

              configuration: this.configuration,

              variant: this.configuration.selectedVariant,

              price: this.configuration.selectedVariant?.price,

              flow: 'STANDARD',

              cartResult: result,

              cartItem: addedItem

            }

          }));

          // Update cart UI with verified data

          this.updateCartUI(currentCart);

          return true;

        } else {

          // Try fallback anyway

          this.updateCartUI();

          return true;

        }

      } else {

        const errorData = await response.json();

        throw new Error(errorData.message || 'Errore durante l\'aggiunta al carrello');

      }

    } catch (error) {

      // Fallback: try with form submission

      const productForm = document.querySelector('form[action*="/cart/add"]');

      if (productForm) {

        return this.fallbackFormSubmission(productForm);

      }

      throw error;

    }

  }

  async fallbackFormSubmission(productForm) {

    try {

      // Update variant selector if exists

      const variantSelector = document.querySelector('select[name="id"]');

      if (variantSelector && this.configuration.selectedVariant) {

        variantSelector.value = this.configuration.selectedVariant.id;

      }

      // Update hidden variant input if exists

      const variantInput = document.querySelector('input[name="id"]');

      if (variantInput && this.configuration.selectedVariant) {

        variantInput.value = this.configuration.selectedVariant.id;

      }

      const configData = [

        { name: 'properties[Formato]', value: this.getFormatLabel(this.configuration.format) },

        { name: 'properties[Colore]', value: this.getColorValue() },

        { name: 'properties[Spessore]', value: this.configuration.thickness || 'Non selezionato' },

        { name: 'properties[_Variante ID]', value: this.configuration.selectedVariant?.id || '' },

        { name: 'properties[_Prezzo Configurato]', value: this.configuration.selectedVariant ? this.formatMoney(this.configuration.selectedVariant.price) : '' },

        { name: 'properties[_Configurazione ID]', value: this.generateConfigId() },

        { name: 'properties[_Configurazione Data]', value: new Date().toISOString() },

        { name: 'properties[_Configuratore]', value: 'FORMAQUAE AI v2.0' },

        { name: 'properties[_Flusso]', value: 'STANDARD' }

      ];

      // Remove existing configuration properties

      productForm.querySelectorAll('input[name^="properties["]').forEach(input => {

        if (input.name.includes('Modello') || input.name.includes('Stile') || 

            input.name.includes('Colore') || input.name.includes('Spessore') || 

            input.name.includes('_Configurazione') || input.name.includes('_Variante') ||

            input.name.includes('_Prezzo') || input.name.includes('_Flusso')) {

          input.remove();

        }

      });

      // Add new configuration properties

      configData.forEach(({ name, value }) => {

        const input = document.createElement('input');

        input.type = 'hidden';

        input.name = name;

        input.value = value;

        productForm.appendChild(input);

      });

      // Submit form

      productForm.submit();

      return true;

    } catch (error) {

      throw error;

    }

  }

  updateCartUI(cartData = null) {

    // Refresh cart content first, then open drawer

    this.refreshCartContent(cartData).then((refreshedCart) => {

      setTimeout(() => {

        this.openCartDrawer();

      }, 800);

    });

  }

  async refreshCartContent(providedCartData = null) {

    try {

      // Use provided cart data or fetch fresh data

      let cartData = providedCartData;

      if (!cartData) {

        const cartResponse = await fetch('/cart.js');

        cartData = await cartResponse.json();

      }

      // Update cart count in header

      const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .Header__CartCount, .cart-link__bubble');

      cartCountElements.forEach(element => {

        if (element) {

          element.textContent = cartData.item_count;

          element.style.display = cartData.item_count > 0 ? 'block' : 'none';

        }

      });

      // Trigger various cart refresh methods

      if (window.CartJS && window.CartJS.getCart) {

        await window.CartJS.getCart();

      }

      if (window.theme && window.theme.updateCart) {

        window.theme.updateCart();

      }

      if (window.ajaxCart && window.ajaxCart.load) {

        window.ajaxCart.load();

      }

      // Dispatch cart events

      const cartEvents = ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart:updated', 'cart:ready'];

      cartEvents.forEach(eventName => {

        document.dispatchEvent(new CustomEvent(eventName, {

          bubbles: true,

          detail: { cart: cartData }

        }));

        window.dispatchEvent(new CustomEvent(eventName, {

          detail: { cart: cartData }

        }));

      });

      // Try to refresh cart drawer content directly

      await this.updateCartDrawerContent(cartData);

      return cartData;

    } catch (error) {

      return null;

    }

  }

  async updateCartDrawerContent(cartData) {

    const cartDrawer = document.querySelector('[data-cart-drawer], .cart-drawer, .drawer--right, #CartDrawer');

    if (!cartDrawer) return;

    // Look for cart items container and update it

    const cartItemsContainer = cartDrawer.querySelector('[data-cart-items], .cart-items, .Cart__ItemList, .drawer__cart-items');

    if (!cartItemsContainer) return;

    try {

      // Try multiple approaches to get cart HTML

      const cartUrls = ['/cart?view=drawer', '/cart?view=ajax', '/cart.js'];

      for (const url of cartUrls) {

        try {

          const response = await fetch(url);

          if (response.ok) {

            if (url.endsWith('.js')) {

              // Skip JSON response for now

              continue;

            }

            const cartHTML = await response.text();

            const tempDiv = document.createElement('div');

            tempDiv.innerHTML = cartHTML;

            const newCartItems = tempDiv.querySelector('[data-cart-items], .cart-items, .Cart__ItemList, .drawer__cart-items');

            if (newCartItems) {

              cartItemsContainer.innerHTML = newCartItems.innerHTML;

              break;

            }

          }

        } catch (err) {

          continue;

        }

      }

      // Fallback: Build cart items manually from cart data

      if (cartData && cartData.items && cartData.items.length > 0) {

        // Find our configured item

        const configuredItem = cartData.items.find(item => 

          item.variant_id === this.configuration.selectedVariant.id &&

          item.properties && 

          item.properties['_Configuratore']

        );

        if (configuredItem) {

          // Add a simple cart item element if container is empty

          if (cartItemsContainer.children.length === 0) {

            const itemEl = document.createElement('div');

            itemEl.className = 'cart-item configured-item';

            itemEl.innerHTML = `

              <div style="padding: 1rem; border: 2px solid #2D5A3D; border-radius: 8px; margin-bottom: 1rem; background: #F5F2EB;">

                <h4 style="margin: 0 0 0.5rem 0; color: #2D5A3D;"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 6px;"><polyline points="20 6 9 17 4 12"></polyline></svg> ${configuredItem.product_title}</h4>

                <p style="margin: 0 0 0.5rem 0; font-size: 0.9rem;">${configuredItem.variant_title}</p>

                <p style="margin: 0; font-weight: bold;">${this.formatMoney(configuredItem.price)} × ${configuredItem.quantity}</p>

                ${configuredItem.properties.Stile ? `<small style="color: #666;">Stile: ${configuredItem.properties.Stile}</small><br>` : ''}

                ${configuredItem.properties.Colore ? `<small style="color: #666;">Colore: ${configuredItem.properties.Colore}</small><br>` : ''}

                ${configuredItem.properties.Spessore ? `<small style="color: #666;">Spessore: ${configuredItem.properties.Spessore}</small>` : ''}

              </div>

            `;

            cartItemsContainer.appendChild(itemEl);

          }

        }

      }

    } catch (error) {

    }

  }

  // 🛒 APERTURA CART DRAWER FIXED - EVITA MENU MOBILE

  openCartDrawer() {

    // Method 1: Selettori specifici per il cart drawer (evitando il menu mobile)

    const specificCartTriggers = [

      '[data-drawer-id="sidebar-cart"]', 

      '[data-drawer-id="cart"]',

      '.js-drawer-open-cart',

      '.Header__CartIcon',

      '[data-action="open-cart-drawer"]',

      '[data-action="open-drawer"][data-drawer="cart"]',

      '.cart-drawer-toggle',

      '.Header__CartCount'

    ];

    let drawerOpened = false;

    for (const selector of specificCartTriggers) {

      const elements = document.querySelectorAll(selector);

      if (elements.length > 0) {

        // Verifica che non sia il menu mobile

        const element = elements[0];

        const isNotMobileMenu = !element.closest('.Header__Icon--nav') && 

                               !element.classList.contains('Header__Icon--nav') &&

                               !element.closest('[data-action="open-sidebar"]') &&

                               !element.closest('.js-drawer-open-nav');

        if (isNotMobileMenu) {

          element.click();

          drawerOpened = true;

          break;

        }

      }

    }

    // Method 2: Cerca elementi che contengono esplicitamente "cart" nel testo o attributi

    if (!drawerOpened) {

      const cartElements = document.querySelectorAll('[class*="cart"], [data-*="cart"], [id*="cart"]');

      for (const element of cartElements) {

        if (element.tagName === 'A' || element.tagName === 'BUTTON') {

          const elementText = element.textContent.toLowerCase();

          const isCartRelated = elementText.includes('cart') || 

                               element.getAttribute('href')?.includes('cart') ||

                               element.getAttribute('data-action')?.includes('cart');

          // Escludi esplicitamente elementi del menu mobile

          const isMobileMenu = element.closest('.Header__Icon--nav') ||

                              element.classList.contains('Header__Icon--nav') ||

                              element.closest('[data-action="open-sidebar"]') ||

                              element.closest('.js-drawer-open-nav') ||

                              element.textContent.toLowerCase().includes('menu') ||

                              element.textContent.toLowerCase().includes('nav');

          if (isCartRelated && !isMobileMenu) {

            element.click();

            drawerOpened = true;

            break;

          }

        }

      }

    }

    // Method 3: Call theme functions

    if (!drawerOpened) {

      setTimeout(() => {

        if (window.theme && window.theme.openCartDrawer) {

          window.theme.openCartDrawer();

          drawerOpened = true;

        } else if (window.Shopify && window.Shopify.drawer && window.Shopify.drawer.open) {

          window.Shopify.drawer.open();

          drawerOpened = true;

        } else if (window.timber && window.timber.RightDrawer) {

          window.timber.RightDrawer.open();

          drawerOpened = true;

        }

      }, 100);

    }

    // Method 4: Manual drawer opening ONLY for cart drawer

    if (!drawerOpened) {

      setTimeout(() => {

        // Selettori specifici per cart drawer (evitando menu mobile)

        const cartDrawers = document.querySelectorAll('[data-cart-drawer], .cart-drawer, .drawer--right[data-drawer="cart"], #CartDrawer');

        cartDrawers.forEach(drawer => {

          if (drawer && !drawer.classList.contains('Header__Icon--nav')) {

            drawer.classList.add('is-open', 'is-visible', 'drawer--open');

            drawer.style.display = 'block';

            drawer.style.transform = 'translateX(0)';

            drawerOpened = true;

          }

        });

        // Add overlay only if cart drawer was opened

        if (drawerOpened) {

          const overlay = document.querySelector('.drawer-overlay, .Overlay') || document.createElement('div');

          if (!overlay.classList.contains('drawer-overlay')) {

            overlay.className = 'drawer-overlay';

            overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 999;';

            document.body.appendChild(overlay);

          }

          overlay.style.display = 'block';

        }

      }, 200);

    }

    // Fallback: Try to redirect to cart page if no drawer found

    if (!drawerOpened) {

      setTimeout(() => {

        window.location.href = '/cart';

      }, 1000);

    }

  }

  getColorValue() {

    return 'Non selezionato';

  }

  getThicknessFromVariant(variant) {

    if (!variant) return null;

    // Cerca lo spessore nelle opzioni della variante

    // PRIORITÀ: cerca prima nelle opzioni che contengono anche il rating (R9/R10/R11)

    const options = [

      variant.option1,

      variant.option2,

      variant.option3,

      variant.title

    ].filter(opt => opt);

    const thicknessPattern = /\d+\s*mm/i;

    const ratingPattern = /r\d+/i;

    // Prima passa: cerca spessore in opzioni che hanno anche rating

    for (const option of options) {

      if (ratingPattern.test(option)) {

        const match = option.match(thicknessPattern);

        if (match) {

          return match[0].replace(/\s/g, '');

        }

      }

    }

    // Seconda passa: se non trova con rating, cerca solo spessore

    for (const option of options) {

      const match = option.match(thicknessPattern);

      if (match) {

        return match[0].replace(/\s/g, '');

      }

    }

    return null;

  }

  findAndSelectMatchingVariant() {

    const format = this.configuration.format;

    const color = this.configuration.color;

    const thickness = this.configuration.thickness;

    const destination = this.configuration.destination;

    // Se non abbiamo tutte le info necessarie, esci

    if (!format) return;

    // Cerca tra tutte le varianti del prodotto

    const allVariants = this.product.variants || [];

    // Trova la variante che corrisponde

    const matchingVariant = allVariants.find(variant => {

      if (!variant.available) return false;

      const variantText = `${variant.title} ${variant.option1} ${variant.option2} ${variant.option3}`.toLowerCase();

      // Verifica formato

      if (format && !variantText.includes(format.toLowerCase())) {

        return false;

      }

      // Verifica colore

      if (color && !variantText.includes(color.toLowerCase())) {

        return false;

      }

      // Verifica spessore

      if (thickness) {

        const variantThickness = this.getThicknessFromVariant(variant);

        if (variantThickness !== thickness) {

          return false;

        }

      }

      // Verifica destinazione (basata su rating antiscivolo)

      if (destination === 'INTERNO') {

        // Deve avere R9 o R10

        if (!variantText.includes('r9') && !variantText.includes('r10')) {

          return false;

        }

      } else if (destination === 'ESTERNO') {

        // Deve avere R11

        if (!variantText.includes('r11')) {

          return false;

        }

      }

      return true;

    });

    if (matchingVariant) {

      this.configuration.selectedVariant = matchingVariant;

      this.configuration.thickness = this.getThicknessFromVariant(matchingVariant);

    } else {

      // Prova a trovare almeno una variante con formato e colore

      const fallbackVariant = allVariants.find(variant => {

        if (!variant.available) return false;

        const variantText = `${variant.title} ${variant.option1} ${variant.option2} ${variant.option3}`.toLowerCase();

        return format && variantText.includes(format.toLowerCase()) && 

               (!color || variantText.includes(color.toLowerCase()));

      });

      if (fallbackVariant) {

        this.configuration.selectedVariant = fallbackVariant;

        this.configuration.thickness = this.getThicknessFromVariant(fallbackVariant);

      }

    }

  }

  getFormatLabel(format) {

    const labels = {};

    return labels[format] || format || 'Non selezionato';

  }

  updateSuccessDetails() {

    const selectedVariant = this.configuration.selectedVariant || this.currentVariant;

    // Calculate savings

    const basePrice = parseFloat(selectedVariant.price);

    const comparePrice = (selectedVariant.compare_at_price && parseFloat(selectedVariant.compare_at_price) > basePrice) ? parseFloat(selectedVariant.compare_at_price) : null;

    const savings = comparePrice ? comparePrice - basePrice : 0;

    const successSavings = document.getElementById('successSavings');

    if (successSavings) {

      if (savings > 0) {

        successSavings.innerHTML = this.formatMoney(savings) + '<span class="fx-iva-tag">IVA incl.</span>';

        successSavings.style.display = '';

      } else {

        successSavings.innerHTML = '';

        successSavings.style.display = 'none';

      }

    }

  }

  // Helper function to format money correctly

  formatMoney(cents) {

    // KH-THOUSANDS 2026-10-01: separatore migliaia manuale (Intl it-IT non raggruppa senza dati ICU completi)
    var p = (cents / 100).toFixed(2).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return p[0] + ',' + p[1] + ' €';

  }

  generateConfigId() {

    return 'FX' + Date.now().toString(36).toUpperCase();

  }

  updateStats() { /* contatore clienti rimosso (audit) */ }

}

/* CSS Animation keyframes */

const style = document.createElement('style');

style.textContent = `

@keyframes fx-carousel-slide {

  0% {

    opacity: 0.8;

    transform: translateX(-50%) scale(0.95);

  }

  100% {

    opacity: 1;

    transform: translateX(-50%) scale(1);

  }

}

`;

document.head.appendChild(style);

function openFxConfigurator() {

  window.ceramicaEuroConfig?.openModal();

}

// Funzioni globali per la navigazione degli step

function nextStep(stepNumber) {

  window.ceramicaEuroConfig?.nextStep();

}

function previousStep(stepNumber) {

  window.ceramicaEuroConfig?.prevStep();

}

// Inizializzazione asincrona per garantire che il DOM sia pronto

document.addEventListener('DOMContentLoaded', () => {

  // Controlla se siamo su una pagina prodotto

  if (window.location.pathname.includes('/products/')) {

    setTimeout(() => {

      window.ceramicaEuroConfig = new CeramicaEuroConfigurator();

      window.ceramicaEuroConfig.setupImageZoomKeyboard();

    }, 1000);

  }

});

// KH-META-PIXEL rimosso: il pixel Meta lo carica il canale "Facebook & Instagram" di Shopify (consent-gated),
// che espone window.fbq globalmente dopo il consenso; gli fbq('track') qui sotto lo riusano (guardati da typeof fbq).

// Event listener per configurazioni applicate

window.addEventListener('fxConfigurationApplied', (event) => {

  // Analytics tracking

  if (typeof gtag !== 'undefined') {

    gtag('event', 'configuration_completed', {

      'event_category': 'engagement',

      'event_label': event.detail.configuration.format || 'default',

      'value': event.detail.variant?.price || 0,

      'custom_parameters': {

        'variant_id': event.detail.variant?.id,

        'variant_title': event.detail.variant?.title,

        'flow_type': event.detail.flow

      }

    });

  }

  // Send to other analytics or tracking services

  if (typeof fbq !== 'undefined') {

    var varId = event.detail.variant?.id;

    fbq('track', 'AddToCart', {

      content_ids: [String(varId)],

      content_type: 'product',

      value: event.detail.variant?.price ? event.detail.variant.price / 100 : 0,

      currency: 'EUR'

    });

  }

  // Try to refresh cart UI after adding

  setTimeout(() => {

    // Look for cart refresh functions

    if (window.CartJS && window.CartJS.getCart) {

      window.CartJS.getCart();

    } else if (window.theme && window.theme.updateCart) {

      window.theme.updateCart();

    } else if (window.timber && window.timber.updateCartPage) {

      window.timber.updateCartPage();

    }

    // Dispatch additional cart events that themes might listen to

    const cartEvents = ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart:updated'];

    cartEvents.forEach(eventName => {

      document.dispatchEvent(new CustomEvent(eventName, {

        detail: event.detail

      }));

      window.dispatchEvent(new CustomEvent(eventName, {

        detail: event.detail  

      }));

    });

  }, 1000);

});

// Gestione errori globale

window.addEventListener('error', (event) => {

  if (event.error && event.error.message.includes('ceramicaEuroConfig')) {

    // Invia l'errore a un servizio di logging se necessario

  }

});

// Calcolo automatico altezza header per mobile (ottimizzato)

let headerHeightRAF = null;

function calculateHeaderHeight() {

  if (headerHeightRAF) return; // Evita chiamate multiple

  headerHeightRAF = requestAnimationFrame(() => {

    const header = document.querySelector('header, .site-header, .Header, .header-wrapper, [data-section-type="header"]');

    if (header) {

      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);

    }

    headerHeightRAF = null;

  });

}

// Esegui al caricamento e al resize (scroll rimosso - non necessario)

document.addEventListener('DOMContentLoaded', calculateHeaderHeight);

window.addEventListener('resize', calculateHeaderHeight);

// Delay singolo per header dinamici

setTimeout(calculateHeaderHeight, 300);

// === V2: PALLET PROGRESS OBSERVER ===

// Osserva cambiamenti nel quantity container per aggiornare la barra progresso pallet

(function() {

  const quantityContainer = document.getElementById('fxQuantityContainer');

  if (!quantityContainer) return;

  const observer = new MutationObserver(() => {

    // Cerca input quantità nel container

    const qtyInput = quantityContainer.querySelector('input[type="number"], input[data-quantity], .fx-qty-input');

    if (!qtyInput) return;

    // Cerca info pallet (da bancale-discount.js)

    const palletInfoEl = quantityContainer.querySelector('[data-pallet-size], [data-box-pal]');

    let palletSize = palletInfoEl ? parseInt(palletInfoEl.dataset.palletSize || palletInfoEl.dataset.boxPal) : null;

    // Fallback: cerca nel testo "bancale" + numero

    if (!palletSize) {

      const textContent = quantityContainer.textContent;

      const match = textContent.match(/(\d+)\s*(?:box|scatole).*?(?:bancale|pallet)/i) || textContent.match(/(?:bancale|pallet).*?(\d+)\s*(?:box|scatole)/i);

      if (match) palletSize = parseInt(match[1]);

    }

    if (palletSize && window.ceramicaEuroConfig) {

      const updateProgress = () => {

        const qty = parseInt(qtyInput.value) || 0;

        window.ceramicaEuroConfig.updatePalletProgress(qty, palletSize);

      };

      qtyInput.removeEventListener('input', updateProgress);

      qtyInput.addEventListener('input', updateProgress);

      qtyInput.removeEventListener('change', updateProgress);

      qtyInput.addEventListener('change', updateProgress);

      // Anche per +/- buttons

      quantityContainer.querySelectorAll('button').forEach(btn => {

        btn.addEventListener('click', () => setTimeout(updateProgress, 50));

      });

      updateProgress();

    }

  });

  observer.observe(quantityContainer, { childList: true, subtree: true });

})();